<template>
    <div class="dev-list">
        <div
                class="preview-bar"
                style="position: fixed; top: 130px; z-index: 2000;background-color: white;height: 60px;border-bottom: 1px solid #efefef; width: 100vw;"
        >
            <div class="preview-bar-operate">
                <div
                        style="border-right: thin solid #ddd;padding: 0 20px 0 0; margin-right: 20px"
                >
                    <el-button
                            type="primary"
                            size="small"
                            v-if="$store.getters.checkChangeAuth()"
                            @click="$router.push('/home/group/dev/manage')"
                    >增减设备
                    </el-button
                    >
                </div>
                <el-checkbox
                        v-model="allChecked"
                        @change="allCheckedChange"
                        style="margin-right: 10px"
                >全选
                </el-checkbox
                >
                <el-dropdown @command="handleCommand">
                    <el-button size="small">
                        批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :disabled="!hasSelect" command="startApk"
                        >启动应用
                        </el-dropdown-item
                        >
                        <el-dropdown-item :disabled="!hasSelect" command="stopApk"
                        >停止应用
                        </el-dropdown-item
                        >
                        <el-dropdown-item :disabled="!hasSelect" command="reboot"
                        >重启设备
                        </el-dropdown-item
                        >
                        <el-dropdown-item :disabled="!hasSelect" command="home"
                        >一键HOME
                        </el-dropdown-item
                        >
                        <el-dropdown-item :disabled="!hasSelect" command="recover"
                        >恢复出厂设置
                        </el-dropdown-item
                        >
                        <el-dropdown-item
                                :disabled="!hasSelect" command="googleInstall"
                        >Google安装
                        </el-dropdown-item
                        >
                        <el-dropdown-item
                                :disabled="!hasSelect"
                                command="googleUnInstall"
                        >Google卸载
                        </el-dropdown-item
                        >
                        <!--<el-dropdown-item v-if="!viewMode" :disabled="!hasSelect || !snapshotComplete" command="snapshot">刷新截图</el-dropdown-item>-->
                    </el-dropdown-menu>
                </el-dropdown>
                <div
                        style="margin-left: 10px;display: flex;flex-direction: row;align-items: flex-start;justify-content: flex-start;"
                >
                    <el-button
                            type="primary"
                            size="small"
                            :disabled="!hasSelect"
                            @click="devSync()"
                    >云机同步
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="small"
                            :disabled="!hasSelect"
                            @click="devShowCpu()"
                    >性能监控
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="small"
                            :disabled="!hasSelect"
                            @click="forceRefreshMedia"
                    >刷新媒体库
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="small"
                            v-if="!viewMode"
                            :disabled="!hasSelect || !snapshotComplete"
                            @click="uploadFilePop"
                    >文件分发
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="small"
                            v-if="!viewMode"
                            :disabled="!hasSelect || !snapshotComplete"
                            @click="snapshotOne"
                    >刷新截图
                    </el-button
                    >
                </div>

                <div
                        style="border-right: 1px solid #ddd; height: 34px; margin-left: 20px;margin-right: 20px; "
                ></div>
            </div>
            <div
                    style="width: 400px; display: flex;flex-direction: row;align-items: flex-start;justify-content: flex-start;"
            >
                <div style="margin-right: 30px;">
                    <!--<span style="font-size: 14px">切换视图：</span>-->
                    <el-button-group>
                        <el-button
                                type="primary"
                                size="small"
                                style="width: 32px;height: 32px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
                                icon="iconfont icon-phone"
                                @click="changeMode(false)"
                        ></el-button>
                        <el-button
                                type="primary"
                                size="small"
                                style="width: 32px;height: 32px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
                                icon="iconfont icon-list"
                                @click="changeMode(true)"
                        ></el-button>
                    </el-button-group>
                </div>
                <el-popover placement="bottom" width="300px" trigger="click">
                    <div
                            style="width:100%;height: 210px; display: flex;flex-direction: column;"
                    >
                        <span class="pop_span">预览图缩放：</span>
                        <div class="pop_button_area">
                            <el-button-group>
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="scaleMode !== 100"
                                        @click="scaleMode = 100"
                                >不缩放
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="scaleMode !== 50"
                                        @click="scaleMode = 50"
                                >50%
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="scaleMode !== 75"
                                        @click="scaleMode = 75"
                                >75%
                                </el-button
                                >

                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="scaleMode !== 150"
                                        @click="scaleMode = 150"
                                >150%
                                </el-button
                                >
                            </el-button-group>
                        </div>
                        <span class="pop_span">云机排序：</span>
                        <div class="pop_button_area">
                            <el-button-group>
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="sortKey !== 0"
                                        @click="sortKey = 0"
                                >默认
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="sortKey !== 1"
                                        @click="sortKey = 1"
                                >云机ID
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="sortKey !== 2"
                                        @click="sortKey = 2"
                                >云机备注
                                </el-button
                                >
                            </el-button-group>
                        </div>
                        <span class="pop_span">截图刷新时间：</span>
                        <div class="pop_button_area">
                            <el-button-group>
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="snapshotTime !== 0"
                                        @click="snapshotTime = 0"
                                >不刷新
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="snapshotTime !== 10"
                                        @click="snapshotTime = 10"
                                >10s
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="snapshotTime !== 30"
                                        @click="snapshotTime = 30"
                                >30s
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="snapshotTime !== 60"
                                        @click="snapshotTime = 60"
                                >60s
                                </el-button
                                >
                            </el-button-group>
                        </div>
                        <span class="pop_span">多开窗口排列方式：</span>
                        <div class="pop_button_area">
                            <el-button-group>
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="displayMode !== 0"
                                        @click="displayMode = 0"
                                >平铺
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        class="pop_button"
                                        size="mini"
                                        :plain="displayMode !== 1"
                                        @click="displayMode = 1"
                                >堆叠
                                </el-button
                                >
                            </el-button-group>
                        </div>
                    </div>
                    <el-button
                            type="primary"
                            size="small"
                            icon="iconfont icon-system"
                            style="width: 120px;height: 32px;display: flex;flex-direction: row;align-items: center; justify-content: center;margin-right: 30px;"
                            slot="reference"
                            @click="openPreviewSetting"
                    >预览界面设置
                    </el-button
                    >
                </el-popover>

            </div>
        </div>

        <div class="bottom-area">
            <div
                    style="width: 15%; display: flex;flex-direction: row; align-items: center;justify-content: flex-start;"
            >
                已选择
                <div style="width: 10%; color: red;">{{ cardSelected }}</div>
                台云机
                <el-button
                        type="text"
                        v-if="cardSelected > 0"
                        style="margin-left: 20px;"
                        @click="cleanSelection()"
                >取消选择
                </el-button
                >
            </div>
            <el-button
                    :plain="checkLicenseService(1) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(1) === -1"
                    @click="ipStartPop()"
            >切换IP
            </el-button
            >
            <el-button
                    :plain="checkLicenseService(1) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(1) === -1"
                    @click="ipClose()"
            >关闭IP
            </el-button
            >
            <el-button
                    :plain="checkLicenseService(2) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(2) === -1"
                    @click="devMasterPop()"
            >设备大师
            </el-button
            >
            <el-button
                    :plain="checkLicenseService(3) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(3) === -1"
                    @click="virtualLocationPop()"
            >虚拟定位
            </el-button
            >
            <el-button
                    :plain="checkLicenseService(8) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(8) === -1"
                    @click="avSwitchPop()"
            >音视频播放
            </el-button
            >
            <el-button
                    type="primary"
                    size="small"
                    :disabled="!hasSelect"
                    @click="importPicPop()"
            >摄像头导入图片
            </el-button
            >
            <el-button
                    :plain="checkLicenseService(7) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(7) === -1"
                    @click="liveManage()"
            >推流直播
            </el-button
            >
            <el-button
                    :plain="checkLicenseService(22) === -1"
                    type="primary"
                    size="small"
                    :disabled="!hasSelect || checkLicenseService(22) === -1"
                    @click="openGuardMaster()"
            >守护大师
            </el-button
            >
        </div>

        <div
                @keyup.enter="changeMode($store.state.groupDevShowMode)"
                style="margin-top: 70px;text-align: left"
        >
            <el-input
                    size="mini"
                    placeholder="输入云机IP/备注操作 搜索"
                    v-model="queryParam"
                    style="width: 320px"
            >
                <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="changeMode($store.state.groupDevShowMode)"
                ></el-button>
            </el-input>
        </div>

        <div
                class="device-case-dev border-all"
                v-if="viewMode"
                style="margin-top: 20px;"
        >
            <el-table
                    ref="multipleTable"
                    :data="info.list"
                    size="mini"
                    :header-cell-style="{ backgroundColor: '#efefef' }"
                    :row-key="rowKey"
                    :row-class-name="tableRowClassName"
                    @row-click="checkRow"
                    tooltip-effect="dark"
                    :height="devTableHeight"
                    style="width: 99%;"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        align="center"
                        header-align="center"
                        :selectable="isCommonCard"
                ></el-table-column>
                <el-table-column prop="id" label="ID" min-width="50px">
                    <template slot-scope="scope">
                        {{ scope.row.cardType === 1 ? scope.row.id : "分层" }}
                    </template>
                </el-table-column>
                <el-table-column prop="slotNo" label="槽位号"></el-table-column>
                <el-table-column prop="deviceIp" label="设备IP"></el-table-column>

                <el-table-column
                        label="设备编号"
                        :show-overflow-tooltip="true"
                        v-if="
            ($store.state.licenseInfo && checkLicenseService(10) !== -1) ||
              checkLicenseService(11) !== -1 ||
              checkLicenseService(12) !== -1
          "
                >
                    <template slot-scope="scope">
                        {{ scope.row | devCodeStr }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="deviceNo"
                        label="设备编号"
                        v-else
                ></el-table-column>

                <el-table-column
                        prop="version"
                        label="设备版本"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="softinstalled"
                        label="应用安装数量"
                ></el-table-column>
                <el-table-column label="状态" width="120px">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" placement="top"
                                    v-if="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1">
                            <span slot="content">{{showDeviceToolTip(scope.row)}}</span>
                            <span :style="scope.row | statusClassFilter">
            {{scope.row | statusStr}}
                                <span :style="scope.row | authStatusClassFilter">
            {{scope.row | authStatusStr}}
          </span>
          </span>

                        </el-tooltip>
                        <span :style="scope.row | statusClassFilter" v-else>
            {{scope.row | statusStr}}
          </span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="disk" label="剩余空间">
                    <template slot-scope="scope">
            <span v-if="scope.row.disk <= 10" style="color: red">{{
              scope.row.disk + "%"
            }}</span>
                        <span v-else>{{ scope.row.disk + "%" }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="150px" label="操作">
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                :disabled="scope.row.deviceStatus !== 0 || (scope.row.deviceMirrorOperationStatus != null && scope.row.deviceMirrorOperationStatus != 5 && scope.row.deviceMirrorOperationStatus != 14) || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1) "
                                @click="initDev(scope.row.deviceIp)"
                                v-if="
                ($store.getters.checkChangeAuth() || !$store.state.isAdmin) &&
                  scope.row.cardType !== 2
              "
                        >
                            恢复出厂
                        </el-button>
                        <el-button
                                type="text"
                                size="small"
                                slot="reference"
                                @click="groupDevPop(scope.row.deviceIp)"
                                :disabled="($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1)"
                                v-if="$store.state.isAdmin && scope.row.cardType !== 2"
                        >分组
                        </el-button>
                        <el-button
                                type="text"
                                size="small"
                                :disabled="scope.row.deviceStatus !== 0 || (scope.row.deviceMirrorOperationStatus != null && scope.row.deviceMirrorOperationStatus != 5 && scope.row.deviceMirrorOperationStatus != 14) || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1)"
                                slot="reference"
                                @click="
                deviceWindowOpen(
                  scope.row.id,
                  scope.row.deviceNo,
                  scope.row.deviceIp,
                  scope.row.remark,
                  scope.row.engineType,
                  scope.row.deviceMirrorOperationStatus,
                  scope.row.isAuth,
                  scope.row.deviceUuid
                )
              "
                                v-if="
                ($store.getters.checkChangeAuth() || !$store.state.isAdmin) &&
                  scope.row.cardType !== 2
              "
                        >
                            控制
                        </el-button>
                        <el-button
                                type="text"
                                size="mini"
                                :disabled="($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1)"
                                @click="changeRemarkPop(scope.row.id, scope.row.remark)"
                        >
                            修改备注
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div class="list-bottom-btn"></div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total"
                >
                </el-pagination>
            </div>

            <Drawer
                    title="设备分组"
                    :visible.sync="groupDevPopShow"
                    @handClick="groupDev"
            >
                <!--<el-dialog title="设备分组" :append-to-body="true" :visible.sync="groupDevPopShow"  width="500px" top="15vh">-->
                <el-select v-model="groupInfo.groupId" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
                <!-- <div slot="footer" class="dialog-footer">
                   <el-button @click="groupDevPopShow = false">取 消</el-button>
                   <el-button type="primary" @click="groupDev">确 定</el-button>
                 </div>-->
            </Drawer>

        </div>
        <div
                class="preview-main"
                v-else
                style="margin-top: 0px;margin-bottom: 50px;"
        >
            <template v-for="(item, index) in info.list">
                <div
                        :key="item.id"
                        class="snapshot-main"
                        :style="{
            'margin-right': '15px',
            'margin-top': '20px',
            border:
              checkLicenseService(10) !== -1 ||
              checkLicenseService(11) !== -1 ||
              checkLicenseService(12) !== -1
                ? item.isContainer === 1
                  ? '1px solid #409eff'
                  : '1px solid red'
                : aaa === index
                ? '1px solid #409eff'
                : '1px solid #f6f6f6'
          }"
                >
                    <el-tooltip
                            class="item"
                            effect="dark"
                            :content="(!$store.state.licenseInfo.hasOwnProperty('isNew') || $store.state.licenseInfo.isNew == 0 || item.deviceUuid.length === 0 || item.isAuth === 1) ?
              (checkLicenseService(4) !== -1
                ? item.deviceIp + ' adb端口：' + adbPortFilter(item)
                : item.deviceIp) : '该设备认证过期，请联系运维人员'
            "
                            placement="top-start"
                    >
                        <div
                                style="text-align: left;display: flex;flex-direction: row;justify-content: space-between;"
                                class="snapshot-main-head"
                        >
                            <el-checkbox
                                    v-model="deviceWindowChecks[index]"
                                    @change="itemCheckedChange"
                                    :style="{ width: (scaleMode === 50 || scaleMode === 75) ? '30px' : '50px' }"
                                    :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                    style="flex-grow: 1;overflow: hidden; white-space: nowrap;"
                            >
                <span style="font-size: 11px;overflow: hidden;width: 100%">{{
                    (scaleMode === 50 || scaleMode === 75) ? item.id : item.remark || item.id
                }}</span>
                            </el-checkbox>
                            <span
                                    :style="item | statusClassFilter"
                                    style="padding-right: 5px;font-size: 11px;display: flex;justify-content: center;align-items: center"
                            >
                {{ getStatus(item.deviceIp) }}
              </span>
                        </div>
                    </el-tooltip>
                    <div
                            class="snapshot-main-img"
                            style="position: relative;"
                            @mouseenter="mouseEnter(index)"
                            @mouseleave="mouseLeave(index)"
                    >
                        <div
                                class="dev_buttons"
                                v-show="aaa === index && scaleMode !== 50 && scaleMode !== 75"
                                @click="
                deviceWindowOpen(
                  item.id,
                  item.deviceNo,
                  item.deviceIp,
                  item.remark,
                  item.engineType,
                  item.deviceMirrorOperationStatus,
                  item.isAuth,
                  item.deviceUuid
                )
              "
                        >
                            <el-button-group>
                                <el-button
                                        type="primary"
                                        size="mini"
                                        :disabled="item.deviceMirrorOperationStatus != null && item.deviceMirrorOperationStatus != 5 && item.deviceMirrorOperationStatus != 14 || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1)"
                                        @click.stop="rebootOneOne(item.deviceIp, item.isContainer)"
                                >重启云机
                                </el-button>

                                <el-button
                                        type="primary"
                                        size="mini"
                                        @click.stop="downloadSnapshot(index)"
                                        :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                >下载截图
                                </el-button
                                >

                                <el-button
                                        type="primary"
                                        size="mini"
                                        @click.stop="showQrCode(item.deviceIp)"
                                        :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                >云机识别码
                                </el-button>

                                <el-button
                                        v-if="checkLicenseService(4) !== -1"
                                        type="primary"
                                        size="mini"
                                        @click.stop="adbOpt(item.deviceIp, 1)"
                                        :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                >打开ADB
                                </el-button>
                                <el-button
                                        v-if="checkLicenseService(4) !== -1"
                                        type="primary"
                                        size="mini"
                                        @click.stop="adbOpt(item.deviceIp, 0)"
                                        :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                >关闭ADB
                                </el-button>

                                <el-button
                                        type="primary"
                                        size="mini"
                                        @click.stop="changeRemarkPop(item.id, item.remark)"
                                        :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                >
                                    修改备注
                                </el-button>
                                <el-button
                                        type="primary"
                                        size="mini"
                                        v-if="item.deviceMirrorOperationStatus !== 12 &&
                 (checkLicenseService(30) !== -1 ||
                    checkLicenseService(31) !== -1)"
                                        @click.stop="openSaveMirror(item.deviceIp, item.engineType)"
                                        :disabled="item.deviceMirrorOperationStatus != null && item.deviceMirrorOperationStatus != 5 && item.deviceMirrorOperationStatus != 14 || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1)"
                                >保存镜像
                                </el-button>
                                <el-button
                                        type="primary"
                                        size="mini"
                                        v-if="item.deviceMirrorOperationStatus !== 12 &&
                 (checkLicenseService(30) !== -1 ||
                    checkLicenseService(31) !== -1)"
                                        @click.stop="openSwitchMirror(item.deviceIp, item.engineType)"
                                        :disabled="item.deviceMirrorOperationStatus != null && item.deviceMirrorOperationStatus != 5 && item.deviceMirrorOperationStatus != 14 || ($store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1)"
                                >切换镜像
                                </el-button>
                                <el-button
                                        type="primary"
                                        size="mini"
                                        v-if="item.deviceMirrorOperationStatus == 12 &&
                 (checkLicenseService(30) !== -1 ||
                    checkLicenseService(31) !== -1)"
                                        @click.stop="cancelSwitchMirror(item.deviceIp)"
                                        :disabled="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && item.deviceUuid.length > 0 && item.isAuth !== 1"
                                >取消切换镜像
                                </el-button>
                            </el-button-group>
                        </div>
                        <div
                                v-show="aaa === index && scaleMode !== 50 && scaleMode !== 75"
                                v-if="
                checkLicenseService(10) !== -1 ||
                  checkLicenseService(11) !== -1 ||
                  checkLicenseService(12) !== -1
              "
                                style="position: absolute;left: 0;bottom: 18px;width: 100%;z-index: 1111;display: flex;flex-direction: row;align-items:center;justify-content: center;"
                        >
                            <el-button plain size="mini" v-if="aaa === index" style="margin:0;width: 60%">
                                {{ showDevCode(item) }}
                            </el-button>
                            <el-button type="primary" size="mini" v-if="aaa === index && item.isContainer === 1 && item.onOff === 2" style="margin:0;width: 40%" @click="bootContainer(item.deviceIp)">
                                开机
                            </el-button>
                            <el-button type="primary" size="mini" v-if="aaa === index && item.isContainer === 1 && (!item.hasOwnProperty('onOff') || item.onOff !== 2)" style="margin:0;width: 40%"  @click="shutdownContainer(item.deviceIp)">
                                关机
                            </el-button>
                        </div>
                        <el-popover
                                placement="right"
                                :disabled="scaleMode !== 50 && scaleMode !== 75"
                                v-model="popover[item.deviceIp]"
                        >
                            <el-image
                                    slot="reference"
                                    :disabled="item.deviceMirrorOperationStatus != null && item.deviceMirrorOperationStatus != 5 && item.deviceMirrorOperationStatus != 14"
                                    @click="
                  deviceWindowOpen(
                    item.id,
                    item.deviceNo,
                    item.deviceIp,
                    item.remark,
                    item.engineType,
                    item.deviceMirrorOperationStatus,
                    item.isAuth,
                    item.deviceUuid
                  )
                "
                                    @mouseover="popover[item.deviceIp] = true"
                                    @mouseout="popover[item.deviceIp] = false"
                                    v-loading="snapshotImgLoading[item.deviceIp]"
                                    element-loading-background="rgba(0, 0, 0, 0.1)"
                                    :style="{ width: imgWidth + 'px'}"
                                    :src="
                  statusImg(item) ||
                    snapshotImg[item.deviceIp] ||
                    ''
                "
                                    style="display: block"
                                    fit="cover"
                            ></el-image>
                            <el-image
                                    v-loading="snapshotImgLoading[item.deviceIp]"
                                    element-loading-background="rgba(0, 0, 0, 0.1)"
                                    style="width: 288px; height: 512px;"
                                    :src="
                  statusImg(item) ||
                    snapshotImg[item.deviceIp] ||
                    ''
                "
                                    fit="cover"
                            ></el-image>
                        </el-popover>

                        <div
                                v-if="checkLicenseService(1) !== -1"
                                style="font-size: 12px;text-align: left;padding: 0 5px;
            height: 18px;display: flex;flex-direction: row;justify-content: flex-start;align-items: center"
                        >
                            IP代理：{{
                            item.proxyStatus === 2
                            ? item.proxyIp
                            : item.proxyStatus === 1
                            ? processProxyName(item.proxyName) + "切换中"
                            : item.proxyStatus === -1 ? "连接失败" : "关"
                            }}
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <Drawer
                title="保存镜像"
                :visible.sync="saveRsyncPopShow"
                @handClick="saveRsync"
        >
            <div>
                <div style="font-size: 14px;">请设置RSYNC服务器用于同步镜像：</div>
                <el-form
                        :model="rsyncInfo"
                        size="small"
                        label-width="150px"
                        label-position="left"
                        style="margin-top: 20px;"
                >
                    <el-form-item
                            size="mini"
                            label="RSYNC服务器："
                            prop="address"
                    >
                        <el-input
                                size="mini"
                                v-model.trim="rsyncInfo.address.paramValue"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="模块：">
                        <el-input
                                size="mini"
                                v-model.trim="rsyncInfo.module.paramValue"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="用户名：">
                        <el-input
                                size="mini"
                                v-model.trim="rsyncInfo.username.paramValue"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="密码：">
                        <el-input
                                size="mini"
                                v-model.trim="rsyncInfo.password.paramValue"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </Drawer>
        <Drawer
                title="保存镜像"
                :visible.sync="saveMirrorPopShow"
                @handClick="saveDeviceMirror"
                :hasClick="clickOnce"
        >
            <div v-if="!currentMirrorRunning">
                <el-form
                        :model="rsyncInfo"
                        size="mini"
                        label-width="120px"
                        label-position="left"
                >
                    <el-form-item
                            size="mini"
                            label="RSYNC服务器："
                            prop="address"
                    >
                        <span>{{ rsyncInfo.address.paramValue }}</span>
                        <el-button
                                size="mini"
                                type="text"
                                style="margin-left: 30px;"
                                @click.stop="saveRsyncPopShow = true"
                        >修改
                        </el-button
                        >
                    </el-form-item>

                    <el-form-item size="mini" label="镜像备注：">
                        <el-input maxlength="20"
                                  size="mini"
                                  v-model.trim="mirrorRemark"
                                  placeholder="请输入"
                                  style="width: 200px;"
                        ></el-input>
                    </el-form-item>
                    <div
                            style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; "
                    >
                        <el-checkbox v-model="isDeviceMasterM"
                        >优先使用设备大师时区/语言
                        </el-checkbox
                        >
                    </div>
                </el-form>
            </div>
            <div v-else="currentMirrorRunning">
                <el-form
                        :model="rsyncInfo"
                        size="mini"
                        label-width="120px"
                        label-position="left"
                >
                    <el-form-item
                            size="mini"
                            label="RSYNC服务器："
                            prop="address"
                    >
                        <span>{{ rsyncInfo.address.paramValue }}</span>
                        <el-button
                                size="mini"
                                type="text"
                                style="margin-left: 30px;"
                                @click.stop="saveRsyncPopShow = true"
                        >修改
                        </el-button
                        >
                    </el-form-item>
                    <el-form-item size="mini" label="当前镜像：">
            <span>{{
              currentMirror.remark.length > 0
                ? currentMirror.remark
                : "无"
            }}</span>
                    </el-form-item>

                    <el-button-group style="margin-bottom: 20px;">
                        <el-button
                                size="mini"
                                :type="!mirrorIsCover ? 'default' : 'primary'"
                                @click.stop="mirrorIsCover = true"
                        >
                            覆盖原镜像
                        </el-button>
                        <el-button
                                size="mini"
                                :type="mirrorIsCover ? 'default' : 'primary'"
                                @click.stop="mirrorIsCover = false"
                        >
                            保存新镜像
                        </el-button>
                    </el-button-group>

                    <el-form-item size="mini" label="镜像备注：" v-if="!mirrorIsCover">
                        <el-input
                                style="width: 200px;"
                                size="mini"
                                v-model.trim="mirrorRemark"
                                placeholder="请输入"
                                maxlength="20"
                        ></el-input>
                    </el-form-item>
                    <div
                            style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; "
                    >
                        <el-checkbox v-model="isDeviceMasterM"
                        >优先使用设备大师时区/语言
                        </el-checkbox
                        >
                    </div>
                </el-form>
            </div>
        </Drawer>
        <Drawer
                title="切换镜像"
                :visible.sync="switchMirrorPopShow"
                @handClick="switchMirrorProcess"
                :hasClick="clickOnce"
        >
            <el-form
                    :model="rsyncInfo"
                    size="mini"
                    label-width="120px"
                    label-position="left"
            >
                <el-form-item
                        size="mini"
                        label="RSYNC服务器："
                        prop="address"
                >
                    <span>{{ rsyncInfo.address.paramValue }}</span>
                    <el-button
                            size="mini"
                            type="text"
                            style="margin-left: 30px;"
                            @click.stop="saveRsyncPopShow = true"
                    >修改
                    </el-button
                    >
                </el-form-item>
                <el-form-item size="mini" label="当前镜像：">
          <span>{{
            currentMirror.remark.length > 0
              ? currentMirror.remark
              : "无"
          }}</span>
                </el-form-item>
                <div style="font-size: 14px;">请选择需要切换的镜像：</div>
                <div class="right-tabbox-newnotice">
                    <el-tabs v-model="activeName" @tab-click="handleSwitchClick">
                        <el-tab-pane label="本机" name="localDevice"></el-tab-pane>
                        <el-tab-pane label="其他云机" name="otherDevice"></el-tab-pane>
                    </el-tabs>
                </div>
                <el-table
                        :header-cell-style="{backgroundColor: '#efefef'}"
                        ref="mirrorTable"
                        :height="mirrorTableHeight"
                        highlight-current-row
                        :data="mirrorTableData.slice((mirrorPage.startPage - 1) * mirrorPage.limit, mirrorPage.startPage * mirrorPage.limit)"
                        size="mini"
                        @current-change="handleMirrorChange"
                        style="width: 100%;margin-top: 10px;"
                >
                    <!--<el-table-column prop="id" label="镜像ID" width="80">-->
                    <!--</el-table-column>-->
                    <el-table-column prop="remark" label="镜像备注" width="200">
                    </el-table-column>
                    <el-table-column prop="updateTime" label="最后修改时间" width="200">
                        <template slot-scope="scope">
                            {{ scope.row.updateTime | formatDateTime }}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="mirror-list-bottom">
                    <el-pagination
                            small
                            @size-change="mirrorSizeChangeHandle"
                            @current-change="currentMirrorChangeHandle"
                            :current-page="mirrorPage.startPage"
                            :page-size="mirrorPage.limit"
                            :page-sizes="[5, 10, 20]"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next"
                            :total="mirrorTableData.length">
                    </el-pagination>
                </div>
                <div style="margin-top: 30px;">
                    <el-checkbox
                            v-model="currentMirrorSave"
                            @change="currentMirrorSaveChange"
                            v-if="currentMirror.remark.length > 0"
                    >当前镜像保存并上传
                    </el-checkbox
                    >
                </div>
                <div style="margin-top: 10px;">
                    <el-checkbox
                            v-model="isDeviceMasterM"
                            v-if="currentMirror.remark.length > 0 && currentMirrorSave"
                    >当前镜像优先使用设备大师时区/语言
                    </el-checkbox
                    >
                </div>
                <!--<div style="color: red; font-size: 14px; height: 56px; line-height: 28px;margin-top: 10px;">-->
                <!--注意：请在剩余空间大于50%时进行操作，剩余空间不足会导致镜像备份失败-->
                <!--</div>-->
            </el-form>
        </Drawer>
        <Drawer
                :title="isApkStart ? '启动应用' : '停止应用'"
                :visible.sync="apkStartStopShow"
                @handClick="startStopApk()"
        >
            <div>
                <el-form
                        ref="form"
                        size="mini"
                        label-width="130px"
                        label-position="left"
                >
                    <el-form-item size="mini" label="分组应用列表：">
                        <!--<el-select v-model="startStopAppid" placeholder="请选择">
                          <el-option
                                  v-for="item in groupAppList"
                                  :key="item.appId"
                                  :label="item.appName + ' ' + item.versionName"
                                  :value="item.appId">
                          </el-option>
                        </el-select>-->
                    </el-form-item>
                    <el-table
                            size="mini"
                            highlight-current-row
                            :data="groupAppList"
                            @current-change="handleCurrentChange"
                            style="width: 100%"
                    >
                        <el-table-column prop="appName" label="应用名称"></el-table-column>
                        <el-table-column prop="versionName" label="版本"></el-table-column>
                    </el-table>
                </el-form>
            </div>
        </Drawer>
        <Drawer title="性能监控" :visible.sync="cpuPopShow">
            <div style="font-size: 12px; font-weight: bold;">
                <div
                        v-for="(item, index) in devCpuList"
                        style="display: flex;flex-direction: column; align-items: flex-start; justify-content: flex-start;margin-bottom: 20px;"
                        :key="item.id"
                >
                    <span>云机ID：{{ item.id }}</span>
                    <span>云机IP：{{ item.deviceIp }}</span>
                    <div
                            :id="'card_cpu-' + index"
                            style="width: 90%; height:200px; "
                    ></div>
                </div>
            </div>
        </Drawer>
        <Drawer
                title="虚拟定位"
                :visible.sync="virtualLocationPopShow"
                @handClick="virtualLocation"
        >
            <div>
                <el-checkbox v-model="ipLocationCheck" style="margin-bottom: 15px;"
                >开启IP智能定位(仅支持中国)
                </el-checkbox
                >
            </div>
            <el-button-group>
                <el-button
                        type="primary"
                        size="small"
                        :plain="virtualLocationMode !== 0"
                        @click="changeVirtualLocationMode(0)"
                >固定地区
                </el-button
                >
                <el-button
                        type="primary"
                        size="small"
                        :plain="virtualLocationMode !== 1"
                        @click="changeVirtualLocationMode(1)"
                >自定义
                </el-button
                >
            </el-button-group>
            <el-form
                    v-if="virtualLocationMode === 0"
                    size="small"
                    label-width="80px"
                    label-position="left"
                    style="margin-top: 10px;"
            >
                <el-form-item size="mini" label="国家：">
                    <el-select :disabled="ipLocationCheck"
                               v-model="areaInfo.nation"
                               placeholder="请选择"
                               @change="getProvinceList"
                    >
                        <template v-for="(item, index) in nationList">
                            <el-option
                                    :key="index"
                                    :label="item.nation"
                                    :value="item.nation"
                            ></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item size="mini" label="省：">
                    <el-select :disabled="ipLocationCheck"
                               v-model="areaInfo.pro"
                               placeholder="请选择"
                               @change="getCityList"
                    >
                        <template v-for="(item, index) in provinceList">
                            <el-option
                                    :key="index"
                                    :label="item.pro"
                                    :value="item.pro"
                            ></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item size="mini" label="市：">
                    <el-select :disabled="ipLocationCheck"
                               v-model="areaInfo.city"
                               placeholder="请选择"
                               @change="getCountyList"
                    >
                        <template v-for="(item, index) in cityList">
                            <el-option
                                    :key="index"
                                    :label="item.city"
                                    :value="item.city"
                            ></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item size="mini" label="区/县：">
                    <el-select v-model="areaInfo.county" placeholder="请选择" :disabled="ipLocationCheck">
                        <template v-for="(item, index) in countyList">
                            <el-option
                                    :key="index"
                                    :label="item.county"
                                    :value="item.county"
                            ></el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form
                    size="small"
                    label-width="80px"
                    label-position="left"
                    style="margin-top: 10px;"
                    v-else
            >
                <el-form-item size="mini" label="基站mcc:">
                    <el-input :disabled="ipLocationCheck"
                              v-model.trim="virtualLocationInfo.mcc"
                              placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item size="mini" label="基站mnc:">
                    <el-input :disabled="ipLocationCheck"
                              v-model.trim="virtualLocationInfo.mnc"
                              placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item size="mini" label="基站cell:">
                    <el-input :disabled="ipLocationCheck"
                              v-model.trim="virtualLocationInfo.cell"
                              placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item size="mini" label="基站lac:">
                    <el-input :disabled="ipLocationCheck"
                              v-model.trim="virtualLocationInfo.lac"
                              placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item size="mini" label="基站lat:">
                    <el-input :disabled="ipLocationCheck"
                              v-model.trim="virtualLocationInfo.lat"
                              placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item size="mini" label="基站lon:">
                    <el-input :disabled="ipLocationCheck"
                              v-model.trim="virtualLocationInfo.lon"
                              placeholder="请输入"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div
                    style="color: red;line-height: 36px; font-size: 18px;margin-top: 15px;"
            >
                注意：部分地区由于app（如美团、微信等）更新，可能造成定位无法识别的情况，请在切换后进行确认。
            </div>
        </Drawer>
        <Drawer
                title="设备大师"
                :visible.sync="devMasterPopShow"
                @handClick="devMaster"
        >
            <el-button-group>
                <el-button
                        type="primary"
                        size="small"
                        :plain="devMasterMode !== 0"
                        @click="changeDevMasterMode(0)"
                >切换机型
                </el-button
                >
                <el-button
                        type="primary"
                        size="small"
                        :plain="devMasterMode !== 1"
                        @click="changeDevMasterMode(1)"
                >清理应用
                </el-button
                >
                <el-button
                        type="primary"
                        size="small"
                        :plain="devMasterMode !== 2"
                        @click="changeDevMasterMode(2)"
                >新建备份
                </el-button
                >
            </el-button-group>
            <el-form
                    v-if="devMasterMode === 0"
                    size="mini"
                    label-width="100px"
                    label-position="left"
                    style="margin-top: 30px;"
            >
                <el-form-item label="机型选择：">
                    <el-button-group>
                        <el-button
                                type="primary"
                                size="mini"
                                :plain="switchModelMode !== 0"
                                @click="changeSwitchModelMode(0)"
                        >随机
                        </el-button
                        >
                        <el-button
                                type="primary"
                                size="mini"
                                :plain="switchModelMode !== 1"
                                @click="changeSwitchModelMode(1)"
                        >指定机型
                        </el-button
                        >
                        <el-button
                                type="primary"
                                size="mini"
                                :plain="switchModelMode !== 2"
                                @click="changeSwitchModelMode(2)"
                        >自定义
                        </el-button
                        >
                    </el-button-group>
                </el-form-item>
            </el-form>
            <el-form
                    v-if="devMasterMode === 0 && switchModelMode === 1"
                    size="mini"
                    label-width="100px"
                    label-position="left"
            >
                <el-form-item label="国家：">
                    <el-select
                            v-model="switchModelInfo.nationId"
                            placeholder="请选择"
                            @change="changeNation"
                    >
                        <el-option
                                v-for="item in nationOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="品牌：">
                    <el-select
                            v-model="switchModelInfo.brand"
                            placeholder="请选择"
                            @change="changeBrandModels"
                    >
                        <el-option
                                v-for="(item, index) in brandModelList"
                                :key="index"
                                :label="item.brand"
                                :value="item.brand"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="型号：">
                    <el-select
                            v-model="switchModelInfo.model"
                            placeholder="请选择"
                            @change="changeModel"
                    >
                        <el-option
                                v-for="item in modelsList"
                                :key="item.model"
                                :label="item.model"
                                :value="item.model"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form
                    v-if="devMasterMode === 0 && switchModelMode === 2"
                    size="mini"
                    label-width="100px"
                    label-position="left"
            >
                <div class="model_selfedit_box">
                    <el-form-item size="mini" label="厂商:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.company"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="品牌:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.brand"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="型号:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.model"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="序列号:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.seriesNum"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="Android Id:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.androidId"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="imei:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.imei"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="imsi:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.imsi"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="wifi mac:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.wifiMac"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="wifi名称:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.wifiName"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="蓝牙名称:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.btname"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="蓝牙mac:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.btaddr"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="手机号:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.phoneno"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="type:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.type"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="user:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.user"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="displayId:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.displayid"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="基带版本:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.baseVersion"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="运营商:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.operatorname"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="运营商代码:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.numeric"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="Country:">
                        <el-input
                                size="mini"
                                v-model.trim="modelInfo.country"
                                placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <el-form
                    v-if="devMasterMode === 0"
                    size="small"
                    label-width="80px"
                    label-position="left"
                    style="margin-top: 20px;"
            >
                <div style="font-size: 14px;font-weight: 600">请选择要清理的应用</div>
                <div class="clean_app_box">
                    <el-checkbox-group
                            v-model="appSelectList"
                            style="display: flex; flex-direction: column;"
                    >
                        <template v-for="app in appListForClean">
                            <el-checkbox
                                    :label="app.packageName"
                                    :key="app.id"
                                    style="margin: 4px 10px;"
                            >{{ app.appName }}
                            </el-checkbox
                            >
                        </template>
                    </el-checkbox-group>
                </div>
                <div
                        style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; margin-top:15px;"
                >
                    <el-checkbox v-model="cleanAppPathCheck">指定路径清理：</el-checkbox>
                    <el-input
                            size="mini"
                            placeholder="请输入"
                            v-model.trim="cleanAppInfo.path"
                            :disabled="!cleanAppPathCheck"
                    ></el-input>
                </div>
                <div
                        style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; "
                >
                    <el-checkbox v-model="cleanAppPowerCheck"
                    >强效清理(清理更彻底，会影响非勾选应用)
                    </el-checkbox
                    >
                </div>
                <div
                        style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; "
                >
                    <el-checkbox v-model="cleanAppRebootCheck"
                    >清理后重启设备
                    </el-checkbox
                    >
                </div>
                <div
                        class="dev-master-others" v-if="switchModelMode != 2"
                >
                    <span style="font-size: 14px; color: #333; width: 120px;">sim卡国家信息：</span>
                    <el-select v-model="simInfoId" placeholder="请选择" size="mini">
                        <el-option
                                v-for="item in simOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div
                        class="dev-master-others"
                >
                    <span style="font-size: 14px; color: #333; width: 120px;">通讯录模拟：</span>
                    <el-input-number v-model="addrBookNum" controls-position="right" :disabled="cleanAddrBookCheck"
                                     @change="handleAddrBookNumChange" :min="0" :max="100"
                                     size="mini"></el-input-number>
                    <el-checkbox v-model="cleanAddrBookCheck" style="margin-left: 20px;"
                    >清空通讯录
                    </el-checkbox
                    >
                </div>
                <div
                        class="dev-master-others"
                >
                    <span style="font-size: 14px; color: #333; width: 120px;">通话记录模拟：</span>
                    <el-input-number v-model="callLogNum" controls-position="right" @change="handleCallNumChange"
                                     :disabled="cleanCallLogCheck"
                                     :min="0"
                                     :max="100" size="mini"></el-input-number>
                    <el-checkbox v-model="cleanCallLogCheck" style="margin-left: 20px;"
                    >清空通话记录
                    </el-checkbox
                    >
                </div>
            </el-form>
            <el-form
                    size="small"
                    label-width="80px"
                    label-position="left"
                    style="margin-top: 20px;"
                    v-if="devMasterMode === 1"
            >
                <div style="font-size: 14px;font-weight: 600">请选择要清理的应用</div>
                <div class="clean_app_box">
                    <el-checkbox-group
                            v-model="appSelectList"
                            style="display: flex; flex-direction: column;"
                    >
                        <template v-for="app in appListForClean">
                            <el-checkbox
                                    :label="app.packageName"
                                    :key="app.id"
                                    style="margin: 4px 10px;"
                            >{{ app.appName }}
                            </el-checkbox
                            >
                        </template>
                    </el-checkbox-group>
                </div>
                <div
                        style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; margin-top: 15px;"
                >
                    <el-checkbox v-model="cleanAppPathCheck">指定路径清理：</el-checkbox>
                    <el-input
                            size="mini"
                            placeholder="请输入"
                            v-model.trim="cleanAppInfo.path"
                            :disabled="!cleanAppPathCheck"
                    ></el-input>
                </div>
                <div
                        style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; "
                >
                    <el-checkbox v-model="cleanAppPowerCheck"
                    >强效清理(清理更彻底，会影响非勾选应用)
                    </el-checkbox
                    >
                </div>
                <div
                        style="display: flex; flex-direction: row; width: 84%; height: 40px; line-height: 40px;font-size: 20px; align-items: flex-start; justify-content: flex-start; "
                >
                    <el-checkbox v-model="cleanAppRebootCheck"
                    >清理后重启设备
                    </el-checkbox
                    >
                </div>
            </el-form>
            <el-form
                    size="small"
                    label-width="80px"
                    label-position="left"
                    style="margin-top: 20px;"
                    v-if="devMasterMode === 2"
            >
                <div style="font-size: 14px;font-weight: 600">请选择要备份的应用</div>
                <div class="clean_app_box">
                    <el-checkbox-group
                            v-model="appSelectList"
                            style="display: flex; flex-direction: column;"
                    >
                        <template v-for="app in appListForBackup">
                            <el-checkbox
                                    :label="app.appId"
                                    :key="app.id"
                                    style="margin: 4px 10px;"
                            >{{ app.appName }}
                            </el-checkbox
                            >
                        </template>
                    </el-checkbox-group>
                </div>
            </el-form>
        </Drawer>
        <Drawer
                title="守护大师"
                :visible.sync="guardMasterPopShow"
                @handClick="guardMasterApps"
        >
            <div style="font-size: 14px;font-weight: 600">请选择要守护的应用</div>
            <div class="guard_master_box">
                <el-checkbox-group
                        v-model="appSelectList"
                        style="display: flex; flex-direction: column; "
                >
                    <template v-for="app in appListForGuard">
                        <el-checkbox
                                :label="app.packageName + ':' + app.activity"
                                :key="app.id"
                                style="margin: 4px 10px;"
                        >{{ app.appName }}
                        </el-checkbox
                        >
                    </template>
                </el-checkbox-group>
            </div>
            <div style="color: red;margin-top: 20px; width: 84%; line-height: 30px;">
                设置后勾选的应用在云机重启后会自动运行，应用仅以最后一次设置为准生效。
            </div>
        </Drawer>
        <!-- 切换IP弹窗 -->
        <Drawer title="切换IP" :visible.sync="ipStartPopShow" @handClick="ipStart">
            <div style="font-size: 12px;">
                <div style="font-size: 14px;font-weight: 600">已选云机：</div>
                <div style="width: 100%;word-wrap: break-word;">
                    {{ ipStartInfo.msg }}
                </div>
                <div class="ip_proxy_tips" v-if="ipStartInfo.global != 1">
                    <span>注意：指定app代理仅支持ssr、socks5和socks5（UDP）协议</span>
                    <span style="margin-left: 40px;">指定app绕行仅支持socks5（UDP）协议</span>
                </div>
                <br/>
                <div style="font-size: 14px;font-weight: 600">选择IP：</div>
                <div style="margin-top: 20px;">
                    功能设置：
                    <el-radio-group v-model="ipStartInfo.global" size="mini" @change="switchProxyApp">
                        <el-radio-button :label="1">全局代理</el-radio-button>
                        <el-radio-button :label="2"
                        >指定app代理
                        </el-radio-button
                        >
                        <el-radio-button :label="3"
                        >指定app绕行
                        </el-radio-button
                        >
                    </el-radio-group>
                </div>
                <div
                        v-if="ipStartInfo.global === 2 || ipStartInfo.global === 3"
                        style="margin-top: 20px; display: flex;flex-direction: column;"
                >
                    <span style="margin-bottom: 6px;">选择应用：</span>
                    <el-checkbox-group v-model="appSelectList">
                        <template v-for="app in ipStartInfo.apps">
                            <el-checkbox :label="app.packageName" :key="app.id">{{
                                app.appName
                                }}
                            </el-checkbox>
                        </template>
                    </el-checkbox-group>
                </div>
                <div style="margin-top: 20px;">
                    自动重连：
                    <el-radio-group v-model="ipStartInfo.autoConnect" size="mini">
                        <el-radio-button :label="0">关</el-radio-button>
                        <el-radio-button :label="1">开</el-radio-button>
                    </el-radio-group>
                </div>
                <div style="margin-top: 20px;">
                    切换方式：
                    <el-button-group>
                        <el-button
                                :type="ipStartInfo.method !== 1 ? 'default' : 'primary'"
                                size="mini"
                                @click="switchProxyType(1)"
                        >随机
                        </el-button
                        >
                        <el-button
                                :type="ipStartInfo.method !== 2 ? 'default' : 'primary'"
                                size="mini"
                                @click="switchProxyType(2)"
                        >指定IP
                        </el-button
                        >
                    </el-button-group>
                </div>
                <div v-if="ipStartInfo.method === 2 && ipStartInfo.global === 1">
                    <el-table
                            :data="ipList"
                            size="mini"
                            ref="ipProxyTable"
                            :height="tableHeight"
                            highlight-current-row
                            @current-change="handleCurrentChangeIp"
                            style="width: 100%"
                    >
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="ip" label="IP"></el-table-column>
                        <el-table-column
                                prop="connectionLast"
                                label="剩余连接数"
                        ></el-table-column>
                        <el-table-column
                                prop="proxyTypeText"
                                label="隧道协议"
                                :formatter="proxyTypeFormat"
                        >
                        </el-table-column>
                    </el-table>
                    <div class="ipproxy-list-bottom">
                        <el-pagination
                                layout="total"
                                :total="ipList.length">
                        </el-pagination>
                    </div>
                </div>
                <div v-if="ipStartInfo.method === 2 && ipStartInfo.global === 2">
                    <el-table
                            :data="socks5List"
                            size="mini"
                            ref="ipProxyTable"
                            :height="tableHeight"
                            highlight-current-row
                            @current-change="handleCurrentChangeIp"
                            style="width: 100%"
                    >
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="ip" label="IP"></el-table-column>
                        <el-table-column
                                prop="connectionLast"
                                label="剩余连接数"
                        ></el-table-column>
                        <el-table-column
                                prop="proxyTypeText"
                                label="隧道协议"
                                :formatter="proxyTypeFormat"
                        >
                        </el-table-column>
                    </el-table>
                    <div class="ipproxy-list-bottom">
                        <el-pagination
                                layout="total"
                                :total="socks5List.length">
                        </el-pagination>
                    </div>
                </div>
                <div v-if="ipStartInfo.method === 2 && ipStartInfo.global === 3">
                    <el-table
                            :data="socks5UdpList"
                            size="mini"
                            ref="ipProxyTable"
                            :height="tableHeight"
                            highlight-current-row
                            @current-change="handleCurrentChangeIp"
                            style="width: 100%"
                    >
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="ip" label="IP"></el-table-column>
                        <el-table-column
                                prop="connectionLast"
                                label="剩余连接数"
                        ></el-table-column>
                        <el-table-column
                                prop="proxyTypeText"
                                label="隧道协议"
                                :formatter="proxyTypeFormat"
                        >
                        </el-table-column>
                    </el-table>
                    <div class="ipproxy-list-bottom">
                        <el-pagination
                                layout="total"
                                :total="socks5List.length">
                        </el-pagination>
                    </div>
                </div>
                <div v-if="ipStartInfo.method === 2 && ipStartInfo.global === 3">
                    <el-table
                            :data="socks5UdpList"
                            size="mini"
                            ref="ipProxyTable"
                            :height="tableHeight"
                            highlight-current-row
                            @current-change="handleCurrentChangeIp"
                            style="width: 100%"
                    >
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="ip" label="IP"></el-table-column>
                        <el-table-column
                                prop="connectionLast"
                                label="剩余连接数"
                        ></el-table-column>
                        <el-table-column
                                prop="proxyTypeText"
                                label="隧道协议"
                                :formatter="proxyTypeFormat"
                        >
                        </el-table-column>
                    </el-table>
                    <div class="ipproxy-list-bottom">
                        <el-pagination
                                layout="total"
                                :total="socks5UdpList.length">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </Drawer>
        <Drawer
                title="摄像头导入图片"
                :visible.sync="importPicPopShow"
                @handClick="importPic"
        >
            <el-form size="small" label-width="140px" label-position="left">
                <el-form-item size="mini" label="选择图片文件">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :headers="$store.getters.getHeaders"
                            :action="$uri.device.writeCameraBatch"
                            :data="uploadPicExtraInfo"
                            accept="image/jpeg, image/png, image/jpg"
                            :limit="1"
                            :multiple="false"
                            :on-change="fileChange"
                            :on-success="handleSuccess"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :auto-upload="false">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </Drawer>
        <!-- 音视频播放弹窗 -->
        <Drawer
                title="音视频播放"
                :visible.sync="avSwitchPopShow"
                @handClick="avSwitch"
        >
            <el-form size="small" label-width="140px" label-position="left">
                <el-form-item label="音视频文件路径：">
                    <el-input
                            v-model.trim="avSwitchInfo.path"
                            placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="循环播放：">
                    <el-switch
                            v-model="avSwitchInfo.isLoop"
                            :active-text="isLoopSwitchName"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :width="44"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否纯音频：">
                    <el-switch
                            v-model="avSwitchInfo.isAudio"
                            :active-text="isAudioOnly"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :width="44"
                    ></el-switch>
                </el-form-item>
                <el-form-item
                        label="注：视频文件支持720x1280，其他分辨率视频会造成画面变形。
            音视频文件需先通过上传文件功能上传至云机后，方可进行音视频播放。"
                        label-width="100%"
                        label-position="left"
                        class="redItem"
                >
                </el-form-item>
            </el-form>
        </Drawer>
        <!-- 修改备注弹窗 -->
        <Drawer
                title="修改备注"
                :visible.sync="changeRemarkPopShow"
                @handClick="changeRemark"
        >
            <el-form size="mini">
                <el-form-item label="云机ID：">{{ changeRemarkInfo.id }}</el-form-item>
                <el-form-item label="备注名称：">
                    <el-input v-model="changeRemarkInfo.remark"></el-input>
                </el-form-item>
            </el-form>
        </Drawer>

        <!-- 多路直播设置弹窗 -->
        <Drawer
                title="推流直播"
                :visible.sync="liveManagePopShow"
                @handClick="live"
        >
            <div>
                <el-form
                        ref="form"
                        size="mini"
                        label-width="160px"
                        label-position="left"
                >
                    <el-form-item size="mini" label="媒体服务器外网地址：">
                        <div v-if="!livePopInfo.mediaAddressWanSet">
                            {{ livePopInfo.mediaAddressWan }}
                            <el-button
                                    type="text"
                                    size="mini"
                                    @click="livePopInfo.mediaAddressWanSet = true"
                            >设置
                            </el-button>
                        </div>
                        <div v-else>
                            <el-input v-model="livePopInfo.mediaAddressWanNew"></el-input>
                            <el-button type="primary" size="mini" @click="changeWan"
                            >确定
                            </el-button
                            >
                            <el-button
                                    size="mini"
                                    @click="livePopInfo.mediaAddressWanSet = false"
                            >取消
                            </el-button
                            >
                        </div>
                    </el-form-item>
                    <el-form-item size="mini" label="媒体服务器内网地址：">
                        <div v-if="!livePopInfo.mediaAddressLanSet">
                            {{ livePopInfo.mediaAddressLan }}
                            <el-button
                                    type="text"
                                    size="mini"
                                    @click="livePopInfo.mediaAddressLanSet = true"
                            >设置
                            </el-button>
                        </div>
                        <div v-else>
                            <el-input v-model="livePopInfo.mediaAddressLanNew"></el-input>
                            <el-button type="primary" size="mini" @click="changeLan"
                            >确定
                            </el-button
                            >
                            <el-button
                                    size="mini"
                                    @click="livePopInfo.mediaAddressLanSet = false"
                            >取消
                            </el-button
                            >
                        </div>
                    </el-form-item>
                    <el-form-item size="mini" label="RTMP URL地址："></el-form-item>
                    <div
                            style="width: 100%; min-height: 200px; max-height: 400px;display: flex;flex-direction: column;font-size: 12px;border: thin solid;padding: 5px;overflow-y: auto"
                    >
                        <div style="display: flex;flex-direction: row;font-size: 14px">
                            <div style="width: 60%;text-align: center; ">RTMP服务器地址</div>
                            <div style="text-align: center">推流密钥</div>
                        </div>
                        <div
                                v-for="(item, index) in livePopInfo.urlList"
                                style="display: flex;flex-direction: row"
                                :key="item.id"
                                :style="{
                backgroundColor:
                  livePopInfo.checked === index ? '#ddd' : 'white',
                padding: '2px'
              }"
                                @click="checkUrl(index)"
                        >
                            <div style="width: 50%;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                                rtmp://{{ livePopInfo.mediaAddressWan }}
                                <span v-if="item.userId === 0" style="color: red">*</span>
                            </div>
                            <div style="width: 40%;text-align: center">{{ item.secretKey }}</div>
                        </div>
                    </div>
                    <div style="display: flex;flex-direction: row;padding: 10px 0">
                        <el-button type="primary" size="mini" @click="createUrl"
                        >生成URL
                        </el-button
                        >
                        <el-button type="primary" size="mini" @click="copyAddress"
                        >复制地址
                        </el-button
                        >
                        <el-button type="primary" size="mini" @click="copyKey"
                        >复制密钥
                        </el-button
                        >
                        <el-button type="danger" size="mini" @click="delUrl"
                        >删除URL
                        </el-button
                        >
                    </div>
                </el-form>
            </div>
        </Drawer>

        <el-drawer
                ref="sync"
                :visible.sync="devSyncShow"
                :append-to-body="true"
                size="100%"
                direction="rtl"
                :show-close="false"
                :destroy-on-close="true"
                :before-close="handleSyncClose"
        >
            <div
                    slot="title"
                    style="display: flex;flex-direction: row;justify-content: flex-start;align-items: flex-end;margin-bottom: -10px;padding-top: 10px"
            >
                <div
                        style="font-size: 20px;font-weight: 600;min-width: 120px;color: black;padding-right: 50px"
                >
                    云机同步操作
                </div>
                <div style="font-size: 12px;min-width: 400px">
                    <div>
                        1.同步云机数不要超过30台，否则很有可能发生卡顿情况。同步过程中发生部分云机画面延迟时，可直接操作云机。
                    </div>
                    <div style="margin-top: 5px">
                        2.自主安装的应用会影响到同步操作，如发生不同步的情况，可直接操作云机。
                    </div>
                </div>
                <div style="flex-grow: 1;text-align: right">
                    <el-button
                            type="primary"
                            style="width: 100px"
                            @click="$refs.sync.closeDrawer()"
                    >退出同步
                    </el-button>
                </div>
            </div>
            <DeviceSync
                    style="border-top: thin solid #ddd"
                    :devList="devSyncList"
                    :deviceStatusStr="deviceStatusStr"
                    @fail="devSyncShow = false"
            ></DeviceSync>
        </el-drawer>

        <el-drawer
                ref="sync2"
                :visible.sync="liveSyncShow"
                :append-to-body="true"
                size="100%"
                direction="rtl"
                :show-close="false"
                :destroy-on-close="true"
                :before-close="handleLiveSyncClose"
        >
            <div
                    slot="title"
                    style="display: flex;flex-direction: row;justify-content: flex-start;align-items: flex-end;margin-bottom: -10px;padding-top: 10px"
            >
                <div
                        style="font-size: 20px;font-weight: 600;min-width: 120px;color: black;padding-right: 50px"
                >
                    推流直播
                </div>
                <div style="font-size: 12px;min-width: 400px">
                    <div v-if="liveSyncShow">
                        RTMP URL：{{
                        livePopInfo.mediaAddressWan +
                        "/" +
                        livePopInfo.urlList[livePopInfo.checked].secretKey
                        }}
                    </div>
                    <div style="margin-top: 5px">
                        推流直播页面拥有云机同步的功能，如果视频卡顿丢帧，请控制视频文件大小或检查网络。
                    </div>
                </div>
                <div style="flex-grow: 1;text-align: right">
                    <el-button
                            type="primary"
                            style="width: 80px"
                            size="mini"
                            @click="$refs.sync2.closeDrawer()"
                    >退出
                    </el-button>
                </div>
            </div>
            <DeviceSync
                    style="border-top: thin solid #ddd"
                    v-if="liveSyncShow"
                    :live="true"
                    :devList="devSyncList"
                    :deviceStatusStr="deviceStatusStr"
                    :address="livePopInfo.mediaAddressWan"
                    :secretKey="livePopInfo.urlList[livePopInfo.checked].secretKey"
                    @fail="devSyncShow = false"
            ></DeviceSync>
        </el-drawer>
        <Drawer title="新增文件" :visible.sync="uploadFilePopShow" @handClick="submitUpload" :before-close="popClose"
                :hasClick="clickOnce">
            <div>
                <el-form ref="form" :model="uploadFileExtraInfo" label-width="130px" label-position="left">
                    <el-form-item size="mini" label="文件存放路径">
                        <el-autocomplete
                                size="small"
                                style="width: 280px"
                                v-model="uploadFileExtraInfo.issuePath"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入路径"/>
                    </el-form-item>
                    <el-form-item size="mini" label="文件备注">
                        <el-input v-model.trim="uploadFileExtraInfo.remark"></el-input>
                    </el-form-item>
                    <div class="mater-upload-container">
                        <ChunkUpload
                                ref="upload"
                                :headers="$store.getters.getHeaders"
                                :chunk-size="chunkSize"
                                @upload_done="uploadFilesDone"
                                @upload_one="uploadOneFileDone"
                                @upload_fail="uploadOneFileFail"
                        >
                        </ChunkUpload>
                    </div>
                </el-form>
            </div>
        </Drawer>
        <el-dialog
                title="云机识别码"
                :visible.sync="qrCodeShow"
                :modal="false"
                width="400px"
        >
            <!--<img :src="qrCodeUrl"/>-->
            <el-image v-if="qrCodeShow" :src="qrCodeUrl" fit="cover"></el-image>
            <div style="display: flex;flex-direction: column">
                <div style="display: flex;flex-direction: column">
                    <div v-if="!mediaServerWan && !wanSetShow" style="color: red">
                        媒体服务器外网地址暂未设置!
                        <el-button
                                type="text"
                                size="mini"
                                @click="wanSetShow = true"
                                style="margin-left: 10px"
                        >快速设置
                        </el-button>
                    </div>
                    <div
                            v-if="wanSetShow"
                            style="display: flex;justify-content: center;align-items: center"
                    >
                        <span>媒体服务器外网地址：</span>
                        <el-input
                                size="mini"
                                v-model="wanNew"
                                style="width: 120px;margin-right: 10px"
                        ></el-input>
                        <el-button type="text" size="mini" @click="wanSet">确定</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Drawer from "@/components/Drawer";
    import DeviceSync from "@/components/DeviceSync";
    import DeviceSync2 from "@/components/DeviceSync2";
    import ChunkUpload from '@/components/ChunkUpload.vue'

    export default {
        name: "GroupListDevShow",
        components: {Drawer, DeviceSync, DeviceSync2, ChunkUpload},
        inject: ['reload'],
        data() {
            return {
                uploadPopCloseTip: false,
                uploadFilePopShow: false,
                clickOnce: false,
                chunkSize: 10 * 1024 * 1024,
                uploadFileExtraInfo: {
                    issuePath: '',
                    deviceIps: '',
                    remark: ''
                },
                uploadFileExtraInfoDefault: {
                    issuePath: '',
                    deviceIps: '',
                    remark: ''
                },
                systemType: 1,
                addFileList: [],
                devAllSelect: false,
                uploadPicExtraInfo: {
                    deviceIps: ''
                },
                importPicPopShow: false,
                simInfoId: 2,
                simInfo: {
                    simId: "",
                    value: ""
                },
                form: {
                    file: ''
                },
                allPhoneModelList: [],
                nationOptions: [{
                    label: "全部",
                    value: 1
                }, {
                    label: "美国",
                    value: 3
                }, {
                    label: "英国",
                    value: 4
                }, {
                    label: "印度尼西亚",
                    value: 5
                }, {
                    label: "泰国",
                    value: 6
                }, {
                    label: "马来西亚",
                    value: 7
                }, {
                    label: "菲律宾",
                    value: 8
                }, {
                    label: "越南",
                    value: 9
                }, {
                    label: "日本",
                    value: 10
                }, {
                    label: "南非",
                    value: 11
                }, {
                    label: "新加坡",
                    value: 12
                }, {
                    label: "德国",
                    value: 13
                }, {
                    label: "巴西",
                    value: 14
                }, {
                    label: "韩国",
                    value: 15
                }, {
                    label: "加拿大",
                    value: 16
                }, {
                    label: "沙特",
                    value: 17
                }, {
                    label: "阿联酋",
                    value: 18
                }, {
                    label: "澳大利亚",
                    value: 19
                }, {
                    label: "波兰",
                    value: 20
                }, {
                    label: "西班牙",
                    value: 21
                }],
                simOptions: [{
                    label: "无sim卡信息",
                    value: 1
                }, {
                    label: "中国sim卡信息",
                    value: 2
                }, {
                    label: "美国sim卡信息",
                    value: 3
                }, {
                    label: "英国sim卡信息",
                    value: 4
                }, {
                    label: "印度尼西亚sim卡信息",
                    value: 5
                }, {
                    label: "泰国sim卡信息",
                    value: 6
                }, {
                    label: "马来西亚sim卡信息",
                    value: 7
                }, {
                    label: "菲律宾sim卡信息",
                    value: 8
                }, {
                    label: "越南sim卡信息",
                    value: 9
                }, {
                    label: "日本sim卡信息",
                    value: 10
                }, {
                    label: "南非sim卡信息",
                    value: 11
                }, {
                    label: "新加坡sim卡信息",
                    value: 12
                }, {
                    label: "德国sim卡信息",
                    value: 13
                }, {
                    label: "巴西sim卡信息",
                    value: 14
                }, {
                    label: "韩国sim卡信息",
                    value: 15
                }, {
                    label: "加拿大sim卡信息",
                    value: 16
                }, {
                    label: "沙特sim卡信息",
                    value: 17
                }, {
                    label: "阿联酋sim卡信息",
                    value: 18
                }, {
                    label: "澳大利亚sim卡信息",
                    value: 19
                }, {
                    label: "波兰sim卡信息",
                    value: 20
                }, {
                    label: "西班牙sim卡信息",
                    value: 21
                }
                ],
                smsNum: 0,
                addrBookNum: 0,
                callLogNum: 0,
                appListNum: 0,
                activeName: 'localDevice',
                rsyncInfo: {
                    address: {
                        id: 0,
                        paramName: "",
                        paramValue: ""
                    },
                    module: {
                        id: 0,
                        paramName: "",
                        paramValue: ""
                    },
                    username: {
                        id: 0,
                        paramName: "",
                        paramValue: ""
                    },
                    password: {
                        id: 0,
                        paramName: "",
                        paramValue: ""
                    }
                },
                rsyncAddress: "",
                rsyncModule: "",
                rsyncUserName: "",
                rsyncPassword: "",
                currentMirror: {
                    id: "",
                    deviceIpUpload: '',
                    deviceIpInuse: '',
                    remark: "",
                    workStatus: 0,
                    operationStatus: 0,
                    createTime: "",
                    updateTime: ""
                },
                currentDeviceIp: "",
                currentDeviceType: 0,
                mirrorRemark: "",
                switchMirrorId: 0,
                mirrorIsCover: false,
                isDeviceMasterM: true,
                currentMirrorList: [],
                currentMirrorRunning: true,
                mirrorTableData: [],
                allMirrorList: [],
                currentMirrorSave: true,
                currentCpu: [],
                currentTime: [],
                cpuTimer: [],
                guardMasterPopShow: false,
                virtualLocationPopShow: false,
                devMasterPopShow: false,
                virtualLocationMode: 0,
                devMasterMode: 0,
                nationList: [],
                provinceList: [],
                cityList: [],
                countyList: [],
                switchModelMode: 0,
                cleanAppPathCheck: false,
                cleanAppPowerCheck: false,
                cleanAppRebootCheck: false,
                cleanAddrBookCheck: false,
                cleanCallLogCheck: false,
                ipLocationCheck: false,
                mediaServerWan: "null",
                wanSetShow: false,
                wanId: 0,
                wanNew: "",
                arCodeIp: "",
                devCpuList: [],
                devSyncShow: false,
                devSyncList: [],
                apkStartStopShow: false,
                isApkStart: false,
                startStopAppid: null,
                startStopApp: null,
                groupAppList: [],
                adbPort: {},
                snapFail: require("../assets/snapfail.png"),
                snapNotUpdate: require("../assets/notupdate.png"),
                snapError: require("../assets/snaperror.png"),
                snapRestart: require("../assets/snaprestart.png"),
                snapShutdown: require("../assets/snapshutdown_cn.png"),
                snapshotImg: {},
                snapshotImgLoading: {},
                deviceStatusStr: {},
                downloadHref: "",
                filename: "",
                qrCodeShow: false,
                qrCodeUrl: "",
                aaa: -1,
                deviceWindowChecks: [],
                oprShowList: [],
                allChecked: false,
                viewMode: false, // true为列表，false为预览
                snapshotSuccess: false,
                popover: {},
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                lowSpaceDeviceList: [],
                page: {
                    startPage: 1,
                    limit: 10
                },
                mirrorPage: {
                    startPage: 1,
                    limit: 5
                },
                oldLimit: 20,
                multipleSelection: [], // 选中的对象列表
                groupDevPopShow: false, // 是否显示分组弹窗
                formLabelWidth: "120px",
                groupInfo: {
                    groupId: "",
                    deviceIp: ""
                },
                options: [],
                avSwitchInfo: {
                    path: "",
                    isLoop: 0,
                    isAudio:0,
                },
                avSwitchPopShow: false,
                advancedShow: false,
                searchOptions: {
                    status: [
                        {
                            label: "正常",
                            value: 0
                        },
                        {
                            label: "未更新",
                            value: 1
                        },
                        {
                            label: "应用安装中",
                            value: 2
                        },
                        {
                            label: "故障",
                            value: 3
                        },
                        {
                            label: "预启动",
                            value: 4
                        },
                        {
                            label: "清理中",
                            value: 5
                        },
                        {
                            label: "升级中",
                            value: 6
                        },
                        {
                            label: "应用结束中",
                            value: 7
                        }
                    ],
                    space: [
                        {
                            label: "充足",
                            value: 0
                        },
                        {
                            label: "不足",
                            value: 1
                        }
                    ],
                    version: []
                },
                timeoutId: 0,

                // ip
                ipStartInfo: {
                    ips: [],
                    proxyId: null,
                    msg: "",
                    autoConnect: 0,
                    method: 1,
                    last: 0,
                    global: 1,
                    apps: []
                },
                appListForGuard: [],
                appListForClean: [],
                appListForBackup: [],
                switchModelInfo: {
                    brand: "",
                    model: "",
                    nationId: ""
                },
                modelInfo: {
                    company: "",
                    brand: "",
                    model: "",
                    seriesNum: "",
                    androidId: "",
                    imei: "",
                    imsi: "",
                    wifiMac: "",
                    wifiName: "",
                    btname: "",
                    btaddr: "",
                    phoneno: "",
                    type: "",
                    user: "",
                    displayId: "",
                    baseVersion: "",
                    operatorname: "",
                    numeric: "",
                    country: ""
                },
                cleanAppInfo: {
                    path: "",
                    isPower: 0,
                    isRestart: 0
                },
                areaInfo: {
                    pro: "",
                    city: "",
                    county: ""
                },
                virtualLocationInfo: {
                    mcc: "",
                    mnc: "",
                    cell: "",
                    lac: "",
                    lat: "",
                    lon: "",
                    isSmart: 0
                },
                saveMirrorPopShow: false,
                saveRsyncPopShow: false,
                switchMirrorPopShow: false,
                brandModelList: [],
                brandList: [],
                modelsList: [],
                appSelectList: [],
                searchInfo: {
                    apkStatus: 1,
                    queryParam: ""
                },
                ipList: [],
                socks5List: [],
                socks5UdpList: [],
                ipStartPopShow: false,
                cpuPopShow: false,
                liveManagePopShow: false,
                livePopInfo: {
                    mediaAddressWan: "",
                    mediaAddressWanName: "",
                    mediaAddressWanNew: "",
                    mediaAddressWanId: -1,
                    mediaAddressWanSet: false,
                    mediaAddressLan: "",
                    mediaAddressLanName: "",
                    mediaAddressLanNew: "",
                    mediaAddressLanId: -1,
                    mediaAddressLanSet: false,
                    urlList: [],
                    checked: 0
                },
                liveSyncShow: false,
                displayMode: 0,
                scaleMode: 100,
                imgWidth: 144,
                snapshotTime: 0,
                snapshotAutoId: null,
                // remark
                changeRemarkPopShow: false,
                changeRemarkInfo: {
                    id: 0,
                    remark: ""
                },
                queryParam: "",
                sortKey: 0,
                tableHeight: 0,
                mirrorTableHeight: 0,
                devTableHeight: 0,
                offsetBottom: 280,
            };
        },

        computed: {
            isLoopSwitchName() {
                return this.avSwitchInfo.isLoop === 1 ? "开" : "关";
            },
            isAudioOnly() {
                return this.avSwitchInfo.isAudio === 1 ? "是" : "否";
            },
            cardSelected() {
                var num = 0;
                if (!this.viewMode) {
                    for (let i = 0; i < this.deviceWindowChecks.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            num++;
                        }
                    }
                } else {
                    num = this.multipleSelection.length;
                }
                return num;
            },
            selectIpsHasContainer() {
                let hasContainer = false
                if (this.viewMode) {
                    this.multipleSelection.forEach(dev => {
                        if (dev.isContainer) {
                            hasContainer = true
                            return
                        }
                    });
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            if (this.info.list[i].isContainer) {
                                hasContainer = true
                            }
                        }
                    }
                }
                return hasContainer;
            },
            selectIpsHasMirrorOps() {
                let mirrorOps = false
                if (this.viewMode) {
                    this.multipleSelection.forEach(dev => {
                        if (dev.deviceMirrorOperationStatus != null && dev.deviceMirrorOperationStatus != 5 && dev.deviceMirrorOperationStatus != 14) {
                            // console.log("dev is " + JSON.stringify(dev))
                            mirrorOps = true
                            return
                        }
                    });
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            if (this.info.list[i].deviceMirrorOperationStatus != null && this.info.list[i].deviceMirrorOperationStatus != 5 && this.info.list[i].deviceMirrorOperationStatus != 14) {
                                // console.log("dev is " + JSON.stringify(this.info.list[i]))
                                mirrorOps = true
                            }
                        }
                    }
                }
                return mirrorOps;
            },
            hasSelect() {
                if (this.viewMode) {
                    return this.multipleSelection.length > 0;
                } else {
                    for (let i = 0; i < this.deviceWindowChecks.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            return true;
                        }
                    }
                    return false;
                }
            },
            imgUrl() {
                return this.snapshotSuccess ? ".jpg?temp=" + new Date().getTime() : "";
            },
            selectIps() {
                let ips = [];
                if (this.viewMode) {
                    this.multipleSelection.forEach(dev => {
                        ips.push(dev.deviceIp);
                    });
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            ips.push(this.info.list[i].deviceIp);
                        }
                    }
                }
                return ips;
            },
            snapshotComplete() {
                let success = false;
                for (let k in this.snapshotImgLoading) {
                    success = success || this.snapshotImgLoading[k];
                }
                return !success;
            },
            phoneModelNationList() {
                let nationListTmp = []
                let idsArr = [1]
                // console.log("phoneModelNationList  111111111111111111111")
                // console.log(JSON.stringify(this.allPhoneModelList))
                if (this.allPhoneModelList && this.allPhoneModelList.length > 0) {
                    this.allPhoneModelList.forEach(item => {
                        // console.log("item is " + JSON.stringify(item))
                        if (item.nationIds && item.nationIds.length > 0) {
                            let ids = item.nationIds.split(",")
                            ids.forEach(id => {
                                if (idsArr.indexOf(id) === -1) {
                                    idsArr.push(id)
                                }
                            })
                        }
                    })
                }
                if (idsArr.length > 0) {
                    idsArr.sort((a, b) => {
                        return a - b
                    })
                    idsArr.forEach(id => {
                        this.nationOptions.forEach(item => {
                            if (item.value == id) {
                                nationListTmp.push(item)
                            }
                        })
                    })
                }
                return nationListTmp
            },
        },
        watch: {
            snapshotTime(n) {
                this.$store.commit(this.$mutation.REFRESH_TIME, n);
                this.snapshotAuto();
            },
            displayMode(n) {
                this.$store.commit(this.$mutation.DISPLAY_MODE, n);
            },
            scaleMode(n) {
                // console.log("scaleMode is " + n)
                this.$store.commit(this.$mutation.SCALE_MODE, n);
                this.imgWidth = (144 * n) / 100;
            },

            sortKey() {
                this.$store.commit(this.$mutation.SORT_MODE, this.sortKey);
                this.info.list.sort((d1, d2) => {
                    if (this.sortKey === 0) {
                        // console.log("d1.deviceIp " + d1.deviceIp + ", d2.deviceIp " + d2.deviceIp)
                        if (d1.isContainer === 0 && d2.isContainer === 0) {
                            return this.ipToInt(d1.deviceIp) - this.ipToInt(d2.deviceIp);
                        }
                    } else if (this.sortKey === 1) {
                        return d1.id >= d2.id ? 1 : -1;
                    } else if (this.sortKey === 2) {
                        if (this.checkNum(d1.remark) && this.checkNum(d2.remark)) {
                            // console.log("sort by number")
                            return Number(d1.remark) - Number(d2.remark);
                        } else {
                            // console.log("sort by string")
                            return d1.remark >= d2.remark ? -1 : 1;
                        }
                    }
                });
                if (this.sortKey === 0) {
                    let listTmp = [];
                    this.info.list.forEach(dev => {
                        if (dev.isContainer === 0) {
                            listTmp.push(dev);
                            this.info.list.forEach(item => {
                                if (item.isContainer === 1 && item.hostIp == dev.deviceIp) {
                                    listTmp.push(item);
                                }
                            });
                        }
                    });
                    this.info.list = JSON.parse(JSON.stringify(listTmp));
                }
                this.$nextTick().then(() => {
                    if (this.$refs.multipleTable) {
                        this.devTableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - this.offsetBottom;
                    }
                    // console.log("tableHeight " + this.devTableHeight)
                })
            }
        },
        methods: {
            bootContainer(containerIp) {
                this.$confirm("确认要开启这台容器?", "提醒", {
                    confirmButtonText: "确认",
                    confirmButtonClass: "confirm-btn-blue",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消",
                    showCancelButton: false
                })
                    .then(() => {
                        this.$post(this.$uri.device.containerOnOff, {containerIp: containerIp, onOff: 1}).then(res => {
                            // console.log("saveAddChunk res " + JSON.stringify(res))
                            if (res.success) {
                                this.$message.success("容器开机成功")
                            } else {
                                this.$message.error("容器开机失败")
                            }
                        })
                    }).catch(() => {
                })

            },
            shutdownContainer(containerIp) {
                this.$confirm("确认要关闭这台容器?", "提醒", {
                    confirmButtonText: "确认",
                    confirmButtonClass: "confirm-btn-blue",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消",
                    showCancelButton: false
                })
                    .then(() => {
                        this.$post(this.$uri.device.containerOnOff, {containerIp: containerIp, onOff: 2}).then(res => {
                            if (res.success) {
                                this.$message.success("容器关机成功")
                            } else {
                                this.$message.error("容器关机失败")
                            }
                        })
                    }).catch(() => {
                })

            },
            uploadFilePop() {
                if (this.selectIpsHasMirrorOps) {
                    this.$confirm("所选云机正在进行镜像操作，不能分发文件", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    this.uploadFileExtraInfo = JSON.parse(JSON.stringify(this.uploadFileExtraInfoDefault))
                    let devIps = []
                    if (this.viewMode) {
                        this.multipleSelection.forEach(dev => {
                            devIps.push(dev.deviceIp);
                        });
                    } else {
                        for (let i = 0; i < this.info.list.length; i++) {
                            if (this.deviceWindowChecks[i] === true) {
                                devIps.push(this.info.list[i].deviceIp);
                            }
                        }
                    }
                    this.uploadFileExtraInfo.deviceIps = devIps.join(",")

                    this.addFileList = []
                    this.uploadFilePopShow = true
                }
            },
            querySearch(queryString, cb) {
                var issuePathHistory = this.getIssuePathHistory()
                var results = queryString ? issuePathHistory.filter(this.createFilter(queryString)) : issuePathHistory
                cb(results)
            },
            createFilter(queryString) {
                return (issuePath) => {
                    return (issuePath.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
                }
            },

            handleSearchHistory() {
                let issuePathArray = localStorage.getItem('issuePath')
                if (issuePathArray) {
                    issuePathArray = issuePathArray.split(',')
                } else {
                    issuePathArray = []
                }
                if (issuePathArray.indexOf(this.uploadFileExtraInfo.issuePath) === -1) {
                    issuePathArray.unshift(this.uploadFileExtraInfo.issuePath)
                }
                if (issuePathArray.length > 20) {
                    issuePathArray.pop()
                }
                localStorage.setItem('issuePath', issuePathArray)
            },
            getIssuePathHistory() {
                let issuePathArray = localStorage.getItem('issuePath')
                if (issuePathArray) {
                    issuePathArray = issuePathArray.split(',')
                }
                let issuePathHistory = []
                for (let i = 0; issuePathArray && i < issuePathArray.length; i++) {
                    let item = {
                        "value": issuePathArray[i],
                        "label": issuePathArray[i]
                    }
                    issuePathHistory.push(item)
                }
                // console.log("issuePathHistory ", issuePathHistory)
                return issuePathHistory
            },
            submitUpload() {
                console.log("uploadFileExtraInfo " + JSON.stringify(this.uploadFileExtraInfo))
                let lowSpaceList = []
                let selectIps = this.uploadFileExtraInfo.deviceIps.split(",")
                selectIps.forEach(item => {
                    if (this.lowSpaceDeviceList.indexOf(item) !== -1) {
                        lowSpaceList.push(item)
                    }
                })
                if (lowSpaceList.length > 0) {
                    let msg = "云机(" + lowSpaceList.join("、") + ")存储空间不足10%，继续分发文件可能导致云机故障造成数据损坏，请清理云机空间后重新进行分发。"
                    this.$confirm(msg, "云机空间不足提醒", {
                        confirmButtonText: '继续分发',
                        confirmButtonClass: 'confirm-btn-red',
                        iconClass: 'el-icon-c-red',
                        showCancelButton: true,
                        cancelButtonText: '取消分发',
                        cancelButtonClass: 'confirm-btn-blue'
                    }).then(() => {
                        this.uploadPopCloseTip = true
                        this.clickOnce = true
                        this.handleSearchHistory()
                        this.$refs.upload.handleUpload()
                    }).catch(() => {
                    })
                } else {
                    this.uploadPopCloseTip = true
                    this.clickOnce = true
                    this.handleSearchHistory()
                    this.$refs.upload.handleUpload()
                }
            },
            popClose() {
                if (this.uploadPopCloseTip) {
                    this.$confirm("文件正在上传中，确定关闭弹窗？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        // this.$refs.upload.clearFiles()
                        this.uploadFilePopShow = false
                    }).catch(() => {
                    })
                } else {
                    this.uploadFilePopShow = false
                    this.uploadFileExtraInfo = {
                        issuePath: '',
                        deviceIps: '',
                    }

                    this.$refs.upload.clearFiles()
                }
            },
            uploadOneFileDone(file) {
                console.log("uploadOneFileDone file " + JSON.stringify(file))
                let that = this
                const body = {
                    fileName: file.fileName,
                    uuid: file.fileHash,
                    ...that.uploadFileExtraInfo
                }
                // console.log("body is " + JSON.stringify(body))
                that.$post(that.$uri.file.saveAddChunk, {...body}).then(res => {
                    // console.log("saveAddChunk res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("上传成功---" + file.fileName)
                        // that.$refs.upload.clearOneFile(file.fileHash)
                    } else {
                        that.$message.error("上传失败---" + file.fileName)
                    }
                })
            },
            uploadFilesDone(file) {
                console.log("uploadFilesDone file " + JSON.stringify(file))
                // console.log("filaName " + file.fileName + " hash: " + file.fileHash)
                const body = {
                    fileName: file.fileName,
                    uuid: file.fileHash,
                    ...this.uploadFileExtraInfo
                }
                // console.log("body is " + JSON.stringify(body))
                this.$post(this.$uri.file.saveAddChunk, {...body}).then(res => {
                    // console.log("saveAddChunk res " + JSON.stringify(res))
                    if (res.success) {
                        this.$message.success("上传完成---" + file.fileName)
                        this.$refs.upload.clearFiles()
                        this.uploadFilePopShow = false
                        this.uploadPopCloseTip = false
                        this.clickOnce = false
                    }
                }).catch(() => {
                    this.$message.error("上传失败---" + file.fileName)
                    this.$refs.upload.clearFiles()
                    this.uploadFilePopShow = false
                    this.uploadPopCloseTip = false
                    this.clickOnce = false
                })
            },
            uploadOneFileFail(errMsg) {
                // console.log("upload fail: " + errMsg)
                this.$message.error("上传失败：" + errMsg)
                this.$refs.upload.clearFiles()
                this.uploadFilePopShow = false
                this.uploadPopCloseTip = false
                this.clickOnce = false
                this.getFileList()
            },
            handleSuccess(response, file, fileList) {
                // console.log("handleSuccess " + JSON.stringify(response))
                if (response.success) {
                    this.$refs.upload.clearFiles()
                    this.$message.success("导入成功")
                    this.importPicPopShow = false
                } else {
                    // console.log(response)
                    this.$message.error(response.message)
                    this.$refs.upload.clearFiles()
                }
            },
            handleRemove(file, fileList) {
                // console.log(file, fileList);
            },
            handlePreview(file) {
                // console.log(file);
            },
            fileChange(file, fileList) {
                this.form.file = file.raw
            },
            handleAppListNumChange(val) {
                this.appListNum = val
            },
            handleCallNumChange(val) {
                this.callLogNum = val
            },
            handleAddrBookNumChange(val) {
                this.addrBookNum = val
            },
            handleSmsNumChange(val) {
                this.smsNum = val
            },

            handleSwitchClick(tab, event) {
                if (this.activeName == 'localDevice') {
                    this.getMirrorList(this.currentDeviceIp, this.currentDeviceType);
                } else {
                    this.getOtherMirrorList()
                }
            },
            switchProxyApp() {
                if (this.ipStartInfo.method === 2) {
                    this.$nextTick().then(() => {
                        if (this.$refs.ipProxyTable) {
                            this.tableHeight = window.innerHeight - this.$refs.ipProxyTable.$el.offsetTop - 100;
                        }
                    })
                }
            },
            switchProxyType(val) {
                // console.log("val is " + val)
                this.ipStartInfo.method = val
                if (this.ipStartInfo.method === 2) {
                    this.$nextTick().then(() => {
                        if (this.$refs.ipProxyTable) {
                            this.tableHeight = window.innerHeight - this.$refs.ipProxyTable.$el.offsetTop - 100;
                        }
                    })
                }
            },
            getAllMirrorList() {
                this.$post(this.$uri.deviceMirror.list).then(res => {
                    if (res.success) {
                        // console.log("allMirrorList is " + JSON.stringify(res.list))
                        this.allMirrorList = res.list;
                    }
                });
            },
            getCurrentMirror(deviceIp) {
                this.currentMirrorRunning = false;
                this.currentMirror = {
                    id: "",
                    deviceIpUpload: '',
                    deviceIpInuse: '',
                    remark: "",
                    workStatus: 0,
                    operationStatus: 0,
                    createTime: "",
                    updateTime: "",
                }
                this.allMirrorList.forEach(mirror => {
                    if (mirror.workStatus === 1 && mirror.deviceIpInuse == deviceIp) {
                        this.currentMirrorRunning = true;
                        this.currentMirror = mirror;
                    }
                });
                this.currentMirror.deviceIp = deviceIp
            },
            async getMirrorList(deviceIp, deviceType) {
                this.currentMirrorList = [];
                this.mirrorTableData = [];

                await this
                    .$post(this.$uri.deviceMirror.list, {
                        deviceIpUpload: deviceIp,
                        engineType: deviceType
                    })
                    .then(res => {
                        console.log("getMirrorList res " + JSON.stringify(res));
                        if (res.success) {
                            this.currentMirrorList = res.list;
                            this.currentMirrorList.forEach(mirror => {
                                if (mirror.workStatus == 0 && (mirror.operationStatus === 5 || mirror.operationStatus === 14)) {
                                    this.mirrorTableData.push(mirror);
                                }
                            });
                        }
                    });
            },
            getOtherMirrorList() {
                this.mirrorTableData = [];
                this
                    .$post(this.$uri.deviceMirror.list)
                    .then(res => {
                        // console.log("getOtherMirrorList res " + JSON.stringify(res));
                        if (res.success) {
                            res.list.forEach(mirror => {
                                if (mirror.workStatus === 0 && mirror.deviceIpUpload != this.currentDeviceIp && (mirror.operationStatus == 5 || mirror.operationStatus == 14) && mirror.engineType == this.currentDeviceType) {
                                    this.mirrorTableData.push(mirror);
                                }
                            });
                        }
                    });
            },
            saveRsync() {
                if (this.$util.isValidURL(this.rsyncInfo.address.paramValue) == false) {
                    this.$confirm("RSYNC服务器地址格式有误，请检查后重试", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-red',
                        showCancelButton: false
                    }).then(() => {
                        return
                    }).catch(() => {
                    })
                    return
                }

                if (this.rsyncAddress !== this.rsyncInfo.address.paramValue) {
                    this
                        .$post(this.$uri.system.paramSave, this.rsyncInfo.address)
                        .then(res => {
                            if (res.success) {
                                this.rsyncAddress = this.rsyncInfo.address.paramValue;
                            } else {
                                this.$message.error("设置RSYNC地址失败");
                            }
                        });
                }
                if (this.rsyncModule !== this.rsyncInfo.module.paramValue) {
                    this.$post(this.$uri.system.paramSave, this.rsyncInfo.module).then(res => {
                        if (res.success) {
                            this.rsyncModule = this.rsyncInfo.module.paramValue;
                        } else {
                            this.$message.error("设置RSYNC模块失败");
                        }
                    });
                }
                if (this.rsyncUserName !== this.rsyncInfo.username.paramValue) {
                    this
                        .$post(this.$uri.system.paramSave, this.rsyncInfo.username)
                        .then(res => {
                            if (res.success) {
                                this.rsyncUserName = this.rsyncInfo.username.paramValue;
                            } else {
                                this.$message.error("设置RSYNC用户名失败");
                            }
                        });
                }
                if (this.rsyncPassword !== this.rsyncInfo.password.paramValue) {
                    this
                        .$post(this.$uri.system.paramSave, this.rsyncInfo.password)
                        .then(res => {
                            if (res.success) {
                                this.rsyncPassword = this.rsyncInfo.password.paramValue;
                            } else {
                                this.$message.error("设置RSYNC密码失败");
                            }
                        });
                }
                setTimeout(() => {
                    this.$message.success("设置RSYNC成功");
                    this.saveRsyncPopShow = false;
                    this.saveMirrorPopShow = true;
                }, 1000);
            },
            getRsyncParams() {
                this
                    .$post(this.$uri.system.paramGet, {paramName: "deviceMirrorRsyncHost"})
                    .then(res => {
                        if (res.success && res.data) {
                            this.rsyncInfo.address.id = res.data.id;
                            this.rsyncInfo.address.paramName = res.data.paramName;
                            this.rsyncInfo.address.paramValue = res.data.paramValue;
                            this.rsyncAddress = this.rsyncInfo.address.paramValue;
                        }
                    });
                this
                    .$post(this.$uri.system.paramGet, {paramName: "deviceMirrorRsyncModule"})
                    .then(res => {
                        if (res.success && res.data) {
                            this.rsyncInfo.module.id = res.data.id;
                            this.rsyncInfo.module.paramName = res.data.paramName;
                            this.rsyncInfo.module.paramValue = res.data.paramValue;
                            this.rsyncModule = this.rsyncInfo.module.paramValue;
                        }
                    });
                this
                    .$post(this.$uri.system.paramGet, {paramName: "deviceMirrorRsyncUsername"})
                    .then(res => {
                        if (res.success && res.data) {
                            this.rsyncInfo.username.id = res.data.id;
                            this.rsyncInfo.username.paramName = res.data.paramName;
                            this.rsyncInfo.username.paramValue = res.data.paramValue;
                            this.rsyncUserName = this.rsyncInfo.username.paramValue;
                        }
                    });
                this
                    .$post(this.$uri.system.paramGet, {paramName: "deviceMirrorRsyncPassword"})
                    .then(res => {
                        if (res.success && res.data) {
                            this.rsyncInfo.password.id = res.data.id;
                            this.rsyncInfo.password.paramName = res.data.paramName;
                            this.rsyncInfo.password.paramValue = res.data.paramValue;
                            this.rsyncPassword = this.rsyncInfo.password.paramValue;
                        }
                    });
            },
            getCityList(pro) {
                this.areaInfo.city = "";
                // console.log("getCityList for " + pro);
                this.$post(this.$uri.virtualLocation.selectCity, {
                    nation: this.areaInfo.nation,
                    pro: pro
                }).then(
                    res => {
                        // console.log("res is " + JSON.stringify(res));
                        if (res.success) {
                            this.cityList = res.list;
                        }
                    }
                );
            },
            getCountyList(city) {
                this.areaInfo.county = "";
                this.$post(this.$uri.virtualLocation.selectCounty, {
                    nation: this.areaInfo.nation,
                    pro: this.areaInfo.pro,
                    city: city
                }).then(res => {
                    // console.log("res is " + JSON.stringify(res));
                    if (res.success) {
                        this.countyList = res.list;
                    }
                });
            },
            changeBrandModels(brand) {
                this.switchModelInfo.model = "";
                this.brandModelList.forEach(item => {
                    if (item.brand === brand) {
                        // console.log("models is " + JSON.stringify(item.models));
                        this.modelsList = item.models;
                    }
                });
            },
            changeNation(nation_id) {
                // console.log("nation_id is " + nation_id);
                // console.log("nationId is " + this.switchModelInfo.nationId)
                this.brandModelList = []
                this.switchModelInfo.brand = "";
                this.switchModelInfo.model = "";
                this.simInfoId = nation_id;
                this.getBrandModel(nation_id);
            },
            changeModel(model_id) {
                // console.log("changeModel id is " + model_id);
            },
            cleanApps(packageNames) {
                if (this.cleanAppPathCheck && this.cleanAppInfo.path.length === 0) {
                    this.$confirm("请填写清理路径", "提醒", {
                        confirmButtonText: "关闭",
                        confirmButtonClass: "confirm-btn-red",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                }
                if (this.cleanAppPowerCheck) {
                    this.cleanAppInfo.isPower = 1;
                } else {
                    this.cleanAppInfo.isPower = 0;
                }
                if (this.cleanAppRebootCheck) {
                    this.cleanAppInfo.isRestart = 1;
                } else {
                    this.cleanAppInfo.isRestart = 0;
                }
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }

                let devNum = devs.length;
                let successCount = 0;
                devs.forEach(dev => {
                    // console.log("deviceIp is " + dev.deviceIp);
                    this
                        .$post(this.$uri.devMaster.cleanApp, {
                            deviceIp: dev.deviceIp,
                            packageNames: packageNames,
                            ...this.cleanAppInfo
                        })
                        .then(res => {
                            if (res.success) {
                                successCount++;
                                if (successCount === devNum) {
                                    this.$message.success("清理应用成功");
                                }
                            } else {
                                this.$message.error("清理应用(" + dev.deviceIp + ")失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("清理应用(" + dev.deviceIp + ")通讯失败");
                        });
                });
            },
            backupApps(appids) {
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }
                let devNum = devs.length;
                let successCount = 0;
                devs.forEach(dev => {
                    // console.log("deviceIp is " + dev.deviceIp);
                    this
                        .$post(this.$uri.devMaster.backup, {
                            deviceIp: dev.deviceIp,
                            appIds: appids
                        })
                        .then(res => {
                            if (res.success) {
                                successCount++;
                                if (successCount === devNum) {
                                    this.$message.success("备份应用成功");
                                }
                            } else {
                                this.$message.error("备份应用(" + dev.deviceIp + ")失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("备份应用(" + dev.deviceIp + ")通讯失败");
                        });
                });
            },
            getBrandModel(id) {
                // console.log("call getBrandModel for " + id)
                let param = {}
                if (id && id > 1) {
                    param.nationId = id
                }
                this.$post(this.$uri.devMaster.getBrandModel, {...param}).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res.success) {
                        this.brandModelList = res.data.list;
                    }
                });
            },
            getNationList() {
                this.$post(this.$uri.virtualLocation.selectNation).then(res => {
                    // console.log("getProvinceList is " + JSON.stringify(res));
                    if (res.success) {
                        this.nationList = res.list;
                    }
                });
            },
            getProvinceList(nation) {
                this.$post(this.$uri.virtualLocation.selectPro, {nation: nation}).then(res => {
                    // console.log("getProvinceList is " + JSON.stringify(res));
                    if (res.success) {
                        this.provinceList = res.list;
                    }
                });
            },
            checkModelInfo() {
                let empty = null;
                for (const key in this.modelInfo) {
                    if (this.modelInfo.hasOwnProperty(key)) {
                        if (this.modelInfo[key] === null || this.modelInfo[key] === "") {
                            empty = true;
                        } else {
                            empty = false;
                            break;
                        }
                    }
                }
                return empty;
            },
            processDevMasterDataModeling() {
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }
                let devNum = devs.length;
                let successCount = 0;
                devs.forEach(dev => {
                    this
                        .$post(this.$uri.devMaster.dataModeling, {
                            deviceIp: dev.deviceIp,
                            smsNum: this.smsNum,
                            addrBookNum: this.cleanAddrBookCheck ? 0 : this.addrBookNum,
                            callLogNum: this.cleanCallLogCheck ? 0 : this.callLogNum,
                            appListNum: this.appListNum,
                            simInfo: this.simInfoId
                        })
                        .then(res => {
                            if (res.success) {
                                console.log("dataModeling success!-----" + dev.deviceIp);
                                successCount++;
                                if (successCount === devNum) {
                                    this.$message.success("数据模拟成功");
                                }
                            } else {
                                this.$message.error("数据模拟(" + dev.deviceIp + ")失败");
                            }
                        });
                })
            },
            devMaster() {
                if (this.devMasterMode === 0) {
                    let devs = [];
                    if (this.viewMode) {
                        devs = this.multipleSelection;
                    } else {
                        for (let i = 0; i < this.info.list.length; i++) {
                            if (this.deviceWindowChecks[i] === true) {
                                devs.push(this.info.list[i]);
                            }
                        }
                    }
                    let devNum = devs.length;
                    let successCount = 0;
                    //切换机型
                    if (this.switchModelMode === 0) {
                        //随机
                        devs.forEach(dev => {
                            this
                                .$post(this.$uri.devMaster.switchModel, {
                                    deviceIp: dev.deviceIp,
                                    isRandom: 1,
                                    simInfo: this.simInfoId
                                })
                                .then(res => {
                                    if (res.success) {
                                        // console.log("switchModel by random success!");
                                        successCount++;
                                        if (successCount === devNum) {
                                            this.$message.success("随机切换机型成功");
                                        }
                                    } else {
                                        this.$message.error("随机切换机型(" + dev.deviceIp + ")失败");
                                    }
                                });
                        });
                        this.devMasterPopShow = false;
                    } else if (this.switchModelMode === 1) {
                        //指定机型（国家+品牌+型号）
                        if (!this.switchModelInfo.nationId || !this.switchModelInfo.brand || !this.switchModelInfo.model) {
                            this.$confirm("国家、品牌或型号不能为空", "提示", {
                                confirmButtonText: '确定',
                                confirmButtonClass: 'confirm-btn-blue',
                                iconClass: 'el-icon-c-blue',
                                cancelButtonText: '取消'
                            }).then(() => {
                            }).catch(() => {
                            })
                        } else {
                            devs.forEach(dev => {
                                this
                                    .$post(this.$uri.devMaster.switchModel, {
                                        deviceIp: dev.deviceIp,
                                        ...this.switchModelInfo,
                                        isRandom: 0,
                                        simInfo: this.simInfoId
                                    })
                                    .then(res => {
                                        if (res.success) {
                                            // console.log("switchModel by random success!");
                                            successCount++;
                                            if (successCount === devNum) {
                                                this.$message.success("切换指定机型成功");
                                            }
                                        } else {
                                            this.$message.error("切换指定机型(" + dev.deviceIp + ")失败");
                                        }
                                    });
                            });
                            this.devMasterPopShow = false;
                        }
                    } else if (this.switchModelMode === 2) {
                        //自定义
                        if (this.checkModelInfo()) {
                            this.$confirm("自定义机型属性不能为空", "提示", {
                                confirmButtonText: '确定',
                                confirmButtonClass: 'confirm-btn-blue',
                                iconClass: 'el-icon-c-blue',
                                cancelButtonText: '取消'
                            }).then(() => {
                            }).catch(() => {
                            })
                        } else {
                            devs.forEach(dev => {
                                this
                                    .$post(this.$uri.devMaster.editDeviceParam, {
                                        deviceIp: dev.deviceIp,
                                        ...this.modelInfo,
                                    })
                                    .then(res => {
                                        if (res.success) {
                                            // console.log("switchModel by random success!");
                                            successCount++;
                                            if (successCount === devNum) {
                                                this.$message.success("切换自定义机型成功");
                                            }
                                        } else {
                                            this.$message.error(
                                                "切换自定义机型(" + dev.deviceIp + ")失败"
                                            );
                                        }
                                    });
                            });
                            this.devMasterPopShow = false;
                        }
                    }
                    //判断是否需要清理应用
                    if (this.appSelectList.length > 0) {
                        let packageNames = this.appSelectList.join(",");
                        this.cleanApps(packageNames);
                    }
                    if (this.smsNum > 0 || this.callLogNum > 0 || this.addrBookNum > 0 || this.appListNum > 0 || this.cleanAddrBookCheck || this.cleanCallLogCheck) {
                        this.processDevMasterDataModeling()
                    }
                } else if (this.devMasterMode === 1) {
                    //清理应用
                    if (this.appSelectList.length === 0) {
                        this.$confirm("请选择至少一个应用", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    } else {
                        let packageNames = this.appSelectList.join(",");
                        this.cleanApps(packageNames);
                        this.devMasterPopShow = false;
                    }
                } else if (this.devMasterMode === 2) {
                    //新建备份
                    if (this.appSelectList.length === 0) {
                        this.$confirm("请选择至少一个应用", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    } else {
                        let appids = this.appSelectList.join(",");
                        this.backupApps(appids);
                        this.devMasterPopShow = false;
                    }
                }
            },
            changeVirtualLocationMode(mode) {
                this.virtualLocationMode = mode;
            },
            changeDevMasterMode(mode) {
                this.devMasterMode = mode;
                this.cleanAppInfo.path = "";
                this.cleanAppInfo.isPower = 0;
                this.cleanAppInfo.isRestart = 0;
                this.appSelectList = [];
            },
            changeSwitchModelMode(mode) {
                this.switchModelMode = mode
                if (mode == 1) {
                    this.brandModelList = []
                    this.modelsList = []
                }
                this.simInfoId = 2
                this.cleanAppInfo.path = ""
                this.cleanAppInfo.isPower = 0
                this.cleanAppInfo.isRestart = 0
                this.appSelectList = []
            },
            openGuardMaster() {
                this.guardMasterPopShow = true;
            },
            avSwitchPop() {
                this.avSwitchPopShow = true;
            },
            importPicPop() {
                this.importPicPopShow = true
            },
            virtualLocationPop() {
                this.virtualLocationPopShow = true;
            },
            virtualLocation() {
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }

                let devNum = devs.length;
                let successCount = 0;
                if (this.virtualLocationMode === 0) {
                    this.areaInfo.isSmart = this.ipLocationCheck ? 1 : 0
                    if (this.areaInfo.isSmart === 0 && (
                        this.areaInfo.pro.length === 0 ||
                        this.areaInfo.city.length === 0 ||
                        this.areaInfo.county.length === 0)
                    ) {
                        this.$confirm("请明确选择省、市、区", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    }

                    for (let dev of devs) {
                        this
                            .$post(this.$uri.virtualLocation.switchByArea, {
                                deviceIp: dev.deviceIp,
                                ...this.areaInfo
                            })
                            .then(res => {
                                if (res.success) {
                                    successCount++;
                                    if (successCount === devNum) {
                                        this.$message.success("虚拟定位设置成功");
                                    }
                                } else {
                                    this.$message.error("虚拟定位(" + dev.deviceIp + ")失败");
                                }
                            })
                            .catch(() => {
                                this.$message.error("虚拟定位(" + dev.deviceIp + ")通讯失败");
                            });
                    }
                } else {
                    this.virtualLocationInfo.isSmart = this.ipLocationCheck ? 1 : 0
                    if (this.virtualLocationInfo.isSmart === 0 && (
                        this.virtualLocationInfo.mcc.length === 0 ||
                        this.virtualLocationInfo.mnc.length === 0 ||
                        this.virtualLocationInfo.cell.length === 0 ||
                        this.virtualLocationInfo.lac.length === 0 ||
                        this.virtualLocationInfo.lat.length === 0 ||
                        this.virtualLocationInfo.lon.length === 0)
                    ) {
                        this.$confirm("自定义选项不能为空", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    }
                    for (let dev of devs) {
                        this
                            .$post(this.$uri.virtualLocation.switch, {
                                deviceIp: dev.deviceIp,
                                ...this.virtualLocationInfo
                            })
                            .then(res => {
                                if (res.success) {
                                    successCount++;
                                    if (successCount === devNum) {
                                        this.$message.success("虚拟定位设置成功");
                                    }
                                } else {
                                    this.$message.error("虚拟定位(" + dev.deviceIp + ")失败");
                                }
                            })
                            .catch(() => {
                                this.$message.error("虚拟定位(" + dev.deviceIp + ")通讯失败");
                            });
                    }
                }

                // this.$message.success("守护大师...");
                this.virtualLocationPopShow = false;
            },
            openPreviewSetting() {
                this.$nextTick().then(() => {
                });
            },
            checkLicenseService(index) {
                let found = -1;
                if (this.$store.state.licenseInfo && this.$store.state.licenseInfo.service) {
                    let serviceItems = this.$store.state.licenseInfo.service.toString().split(",");
                    for (let item of serviceItems) {
                        if (item == index) {
                            found = 1;
                            break;
                        }
                    }
                }
                return found;
            },

            ipToInt(ip) {
                var REG = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
                var result = REG.exec(ip);
                if (!result) return -1;
                return (
                    parseInt(result[1]) * 0x1000000 +
                    parseInt(result[2]) * 0x10000 +
                    parseInt(result[3]) * 0x100 +
                    parseInt(result[4])
                );
            },

            checkNum(val) {
                var reg = /^[0-9]+.?[0-9]*$/;
                if (reg.test(val)) {
                    return true;
                } else {
                    return false;
                }
            },
            /* 获取分组内应用列表 */
            getAppsForDeviceGroup() {
                this.appSelectList = [];
                this
                    .$post(this.$uri.apk.apkList, {
                        groupId: this.$store.state.groupInfo.id,
                        ...this.searchInfo
                    })
                    .then(res => {
                        // console.log("getAppsForDeviceGroup res is " + JSON.stringify(res))
                        this.ipStartInfo.apps = res.list;
                        this.appListForGuard = res.list;
                        this.appListForClean = res.list;
                        this.appListForBackup = res.list;
                    });
            },
            getContainerIdByIP(ip) {
                let ips = ip.split(".");
                return Math.floor(ips[2] / 64);
            },
            showDevCode(dev) {
                // console.log("showDevCode")
                var showName = "";
                if (dev.isContainer === 1) {
                    if (dev.engineType <= 12 || dev.engineType == 17 || dev.engineType == 18 || dev.engineType == 23) {
                        showName = "容器-ry";
                    } else if ((dev.engineType >= 13 && dev.engineType <= 15) || dev.engineType === 22) {
                        showName = "容器-gt";
                    } else {
                        showName = "容器-ot";
                    }
                    if (this.allMirrorList.length > 0) {
                        this.allMirrorList.forEach(mirror => {
                            // console.log("deviceIp is " + dev.deviceIp + " mirror is " + JSON.stringify(mirror))
                            if (
                                mirror.containerIp == dev.deviceIp &&
                                mirror.workStatus == 1 &&
                                mirror.remark.length > 0
                            ) {
                                // console.log("find mirror")
                                showName = mirror.remark;
                                return;
                            }
                        });
                    }
                } else if (dev.isContainer === 0) {
                    if (dev.engineType <= 12 || dev.engineType == 17 || dev.engineType == 18 || dev.engineType == 23) {
                        showName = "宿主机-ry";
                    } else if ((dev.engineType >= 13 && dev.engineType <= 15) || dev.engineType === 22) {
                        showName = "宿主机-gt";
                    } else {
                        showName = "宿主机-ot";
                    }
                }
                return showName;
            },
            proxyTypeFormat(row, column) {
                if (row.proxyType === 2) {
                    return "PPTP";
                } else if (row.proxyType === 3) {
                    return "L2TP";
                } else if (row.proxyType === 4) {
                    return "Socks5";
                } else if (row.proxyType === 5) {
                    return "http";
                } else if (row.proxyType === 6) {
                    return "ssr";
                } else if (row.proxyType === 7) {
                    return "Socks5(UDP)";
                } else {
                    return "OpenVPN";
                }
            },
            wanSet() {
                this.$post(this.$uri.system.paramSave, {
                    id: this.wanId,
                    paramName: "mediaServerWan",
                    paramValue: this.wanNew
                }).then(res => {
                    if (res.success) {
                        this.mediaServerWan = this.wanNew;
                        this.wanSetShow = false;
                        this.$post(this.$uri.device.qrCode, {deviceIp: this.qrCodeIp}).then(
                            res => {
                                this.qrCodeUrl = res.data;
                            }
                        );
                    } else {
                        this.$message.error("修改失败");
                    }
                });
            },
            snapshotAuto() {
                if (this.snapshotAutoId) {
                    clearInterval(this.snapshotAutoId);
                }
                if (this.snapshotTime > 0) {
                    this.snapshotAutoId = setInterval(
                        this.snapshotAll,
                        this.snapshotTime * 1000
                    );
                }
            },
            copyAddress() {
                if (!this.livePopInfo.urlList[this.livePopInfo.checked]) {
                    this.$message.error("未选择URL");
                    return;
                }
                this.$copyText("rtmp://" + this.livePopInfo.mediaAddressWan).then(
                    res => {
                        this.$message.success("复制成功");
                    },
                    res => {
                        this.$message.error("复制失败");
                    }
                );
            },
            copyKey() {
                if (!this.livePopInfo.urlList[this.livePopInfo.checked]) {
                    this.$message.error("未选择URL");
                    return;
                }
                this.$copyText(
                    this.livePopInfo.urlList[this.livePopInfo.checked].secretKey
                ).then(
                    res => {
                        this.$message.success("复制成功");
                    },
                    res => {
                        this.$message.error("复制失败");
                    }
                );
            },
            createUrl() {
                if (
                    !this.livePopInfo.mediaAddressWan ||
                    !this.livePopInfo.mediaAddressLan
                ) {
                    this.$message.warning("请先设置媒体服务器地址");
                    return;
                }
                this.$post(this.$uri.live.add).then(res => {
                    if (res.success) {
                        this.$message.success("生成成功");
                        this.getUrlList();
                    } else {
                        this.$message.error("生成失败");
                    }
                });
            },
            delUrl() {
                this
                    .$post(this.$uri.live.del, {
                        id: this.livePopInfo.urlList[this.livePopInfo.checked].id
                    })
                    .then(res => {
                        if (res.success) {
                            this.$message.success("删除成功");
                            this.getUrlList();
                        } else {
                            this.$message.error("删除失败");
                        }
                    });
            },
            live() {
                if (!this.livePopInfo.urlList[this.livePopInfo.checked]) {
                    this.$message.error("未选择URL");
                    return;
                }
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }
                // if (devs.length < 2) {
                //     this.$message.warning("请选择2台以上的设备");
                //     return;
                // }
                console.log("devs is " + JSON.stringify(devs))
                this.devSyncList = devs;
                if (this.devSyncList.length > 1) {
                    this.liveSyncShow = true;
                } else {
                    this.sync()
                }
            },
            sync() {
                let ips = []
                this.devSyncList.forEach(dev => {
                    ips.push(dev.deviceIp)
                })
                // console.log("sync ips " + JSON.stringify(ips))
                if (this.live) {
                    this.$post(this.$uri.live.start, {
                        deviceIps: ips.join(','),
                        mediaServer: this.livePopInfo.mediaAddressWan,
                        secretKey: this.livePopInfo.urlList[this.livePopInfo.checked].secretKey
                    }).then(res => {
                        // console.log("res is " + JSON.stringify(res))
                        if (res.success) {
                            this.$message.success("推流直播请求成功")
                        } else {
                            this.$message.error('推流直播请求失败')
                        }
                    }).finally(() => {
                        this.liveManagePopShow = false
                    })
                }
            },
            checkUrl(id) {
                this.livePopInfo.checked = id;
            },
            changeLan() {
                this.$confirm(
                    "媒体服务器内网地址修改后，原有地址将失效并自动将RTMP服务器更换为新的地址，请及时更换直播工具的RTMP服务器地址。",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-blue",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        this
                            .$post(this.$uri.system.paramSave, {
                                id: this.livePopInfo.mediaAddressLanId,
                                paramName: this.livePopInfo.mediaAddressLanName,
                                paramValue: this.livePopInfo.mediaAddressLanNew
                            })
                            .then(res => {
                                if (res.success) {
                                    this.livePopInfo.mediaAddressLan =
                                        this.livePopInfo.mediaAddressLanNew;
                                    this.livePopInfo.mediaAddressLanSet = false;
                                } else {
                                    this.$message.error("修改失败");
                                }
                            });
                    })
                    .catch(() => {
                    });
            },
            changeWan() {
                this.$confirm(
                    "媒体服务器外网地址修改后，原有地址将失效并自动将RTMP服务器更换为新的地址，请及时更换直播工具的RTMP服务器地址。",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-blue",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        this
                            .$post(this.$uri.system.paramSave, {
                                id: this.livePopInfo.mediaAddressWanId,
                                paramName: this.livePopInfo.mediaAddressWanName,
                                paramValue: this.livePopInfo.mediaAddressWanNew
                            })
                            .then(res => {
                                if (res.success) {
                                    this.livePopInfo.mediaAddressWan =
                                        this.livePopInfo.mediaAddressWanNew;
                                    this.livePopInfo.mediaAddressWanSet = false;
                                } else {
                                    this.$message.error("修改失败");
                                }
                            });
                    })
                    .catch(() => {
                    });
            },
            handleCurrentChange(row) {
                this.startStopAppid = row.appId;
                this.startStopApp = row;
            },
            handleMirrorChange(row) {
                // console.log("handleMirrorChange ")
                if (row) {
                    this.switchMirrorId = row.id;
                }
            },
            handleCurrentChangeIp(row) {
                if (row != null) {
                    this.ipStartInfo.proxyId = row.id;
                    this.ipStartInfo.last = row.connectionLast;
                }
            },
            handleSyncClose(done) {
                this.$confirm("确认要退出云机同步？")
                    .then(_ => {
                        this.devSyncList = [];
                        done();
                    })
                    .catch(_ => {
                    });
            },
            handleLiveSyncClose(done) {
                this.$confirm("确定退出？")
                    .then(_ => {
                        this.devSyncList = [];
                        done();
                    })
                    .catch(_ => {
                    });
            },
            devSync() {
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }
                if (devs.length < 2) {
                    this.$message.warning("请选择2台以上的设备");
                    return;
                }
                this.devSyncList = devs;
                this.devSyncShow = true;
            },
            devShowCpu() {
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }
                // console.log("devs is " + JSON.stringify(devs));
                this.devCpuList = [];
                let timeInit = this.getCurrentTime();
                devs.forEach(item => {
                    item.currentCpu = [0, 0, 0, 0, 0, 0, 0, 0];
                    item.currentTime = [
                        timeInit,
                        timeInit,
                        timeInit,
                        timeInit,
                        timeInit,
                        timeInit,
                        timeInit,
                        timeInit
                    ];
                    this.devCpuList.push(item);
                });
                // this.devCpuList = devs
                // console.log("devCpuList is " + JSON.stringify(this.devCpuList));
                this.cpuPopShow = true;
                this.devCpuList.forEach((item, index) => {
                    console.log("index is " + index);
                    this.$nextTick().then(() => {
                        this.getEchartData(index);
                    });

                    this.cpuTimer[index] = setInterval(() => {
                        if (this.cpuPopShow === false) {
                            clearInterval(this.cpuTimer[index]);
                            return;
                        }
                        this.getEchartData(index);
                    }, 5000);
                });
            },
            getCurrentTime() {
                let current = new Date();
                return (
                    (current.getMinutes() > 9
                        ? current.getMinutes()
                        : "0" + current.getMinutes()) +
                    ":" +
                    (current.getSeconds() > 9
                        ? current.getSeconds()
                        : "0" + current.getSeconds())
                );
            },
            processCpuValue(index, value) {
                this.devCpuList[index].currentCpu.push(value);
                if (this.devCpuList[index].currentCpu.length > 8) {
                    this.devCpuList[index].currentCpu.shift();
                    console.log(
                        index +
                        " currentCpu is " +
                        JSON.stringify(this.devCpuList[index].currentCpu)
                    );
                }
                let time = this.getCurrentTime();
                this.devCpuList[index].currentTime.push(time);
                if (this.devCpuList[index].currentTime.length > 8) {
                    this.devCpuList[index].currentTime.shift();
                    console.log(
                        index +
                        "currentTime is " +
                        JSON.stringify(this.devCpuList[index].currentTime)
                    );
                }
            },
            getEchartData(index) {
                this
                    .$post(this.$uri.device.edit, {
                        deviceIp: this.devCpuList[index].deviceIp
                    })
                    .then(res => {
                        if (res.success && res.data.cpu) {
                            this.processCpuValue(index, res.data.cpu);
                            this.showCpuEchart(index);
                        } else {
                            this.processCpuValue(index, 0);
                            this.showCpuEchart(index);
                        }
                    });
            },
            showCpuEchart(index) {
                // console.log("showCpuEchart id is " + index);
                var myChart = this.$echarts.init(
                    document.getElementById("card_cpu-" + index)
                );

                var option = {
                    //标题
                    title: {
                        text:
                        "当前CPU使用率" +
                        this.devCpuList[index].currentCpu.slice(-1)[0] +
                        "%"
                    },
                    grid: {
                        left: "3%", //图表距边框的距离
                        right: "4%",
                        bottom: "3%",
                        containLabel: true
                    },
                    tooltip: {
                        trigger: "axis"
                    },

                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: this.devCpuList[index].currentTime,
                        //坐标轴颜色
                        axisLine: {
                            lineStyle: {
                                color: "gray"
                            }
                        },
                        //x轴文字旋转
                        axisLabel: {
                            rotate: 30,
                            interval: 0
                        }
                    },

                    yAxis: {
                        max: 100,
                        // min:0,
                        type: "value",
                        minInterval: 0,
                        interval: 25 //每次增加几个
                    },
                    //数据-data是最终要显示的数据
                    series: [
                        {
                            name: "",
                            type: "line",
                            symbolSize: 4,
                            areaStyle: {
                                normal: {color: "#80ffc0"}
                            },
                            color: ["blue"],
                            data: this.devCpuList[index].currentCpu
                        }
                    ]
                };
                //使用刚刚指定的配置项和数据项显示图表
                myChart.setOption(option);
            },
            getAllPhoneModelList() {
                this.$post(this.$uri.dbPhone.list).then(res => {
                    if (res.success) {
                        this.allPhoneModelList = res.list
                        // console.log("allPhoneModelList is " + JSON.stringify(res))
                    }
                })
            },
            devMasterPop() {
                this.simInfoId = 2
                this.smsNum = 0
                this.addrBookNum = 0
                this.callLogNum = 0
                this.appListNum = 0
                this.cleanAppPathCheck = false
                this.cleanAppPowerCheck = false
                this.cleanAppRebootCheck = false
                this.cleanAddrBookCheck = false
                this.cleanCallLogCheck = false
                this.appSelectList = []
                this.switchModelInfo = {
                    brand: "",
                    model: "",
                    nationId: ""
                }
                this.getBrandModel("")
                this.getAllPhoneModelList()
                this.devMasterPopShow = true;
            },
            ipStartPop() {
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }

                let ips = [];
                let msgs = [];
                devs.forEach(dev => {
                    ips.push(dev.deviceIp);
                    msgs.push(dev.id + "(" + dev.deviceIp + ")");
                });
                this.ipStartInfo.ips = ips;
                this.ipStartInfo.msg = msgs.join("，");

                let params = {}
                if (this.$store.state.userInfo.groupType == 2) {
                    params = {userId: this.$store.state.userInfo.id}
                }
                this.$post(this.$uri.ipProxy.list, params).then(res => {
                    if (res.success) {
                        let list = res.list.filter(i => {
                            return i.isUsable === 1;
                        });
                        list.sort((a, b) => {
                            return b.connectionLast - a.connectionLast;
                        });
                        this.ipList = list;
                        this.socks5List = list.filter(ip => {
                            return ip.proxyType === 4 || ip.proxyType === 6 || ip.proxyType === 7;
                        });
                        this.socks5UdpList = list.filter(ip => {
                            return ip.proxyType === 7;
                        });
                    }
                });
                this.ipStartPopShow = true;
            },
            guardMasterApps() {
                var packageNames = "";
                if (this.appSelectList.length === 0) {
                    this.$confirm("请选择至少一个应用", "提醒", {
                        confirmButtonText: "关闭",
                        confirmButtonClass: "confirm-btn-red",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                } else {
                    packageNames = this.appSelectList.join(",");
                }
                // console.log("appSelectList For Guard " + packageNames);
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }
                let devNum = devs.length;
                let successCount = 0;
                devs.forEach(dev => {
                    // console.log("deviceIp is " + dev.deviceIp);
                    // console.log("packageClassNames " + JSON.stringify(packageNames))
                    this
                        .$post(this.$uri.guardMaster.guardApp, {
                            deviceIp: dev.deviceIp,
                            packageClassNames: packageNames
                        })
                        .then(res => {
                            if (res.success) {
                                successCount++;
                                if (successCount === devNum) {
                                    this.$message.success("守护大师设置成功");
                                }
                            } else {
                                this.$message.error("守护大师(" + dev.deviceIp + ")失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("守护大师(" + dev.deviceIp + ")通讯失败");
                        });
                });
                // this.$message.success("守护大师...");
                this.guardMasterPopShow = false;
            },
            ipStart() {
                var packageNames = "";
                if (this.ipStartInfo.global === 2) {
                    if (this.appSelectList.length === 0) {
                        this.$confirm("请选择至少一个应用走socks5代理", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    } else {
                        packageNames = this.appSelectList.join(",");
                    }
                }
                else if (this.ipStartInfo.global === 3) {
                    if (this.appSelectList.length > 0) {
                        packageNames = this.appSelectList.join(",");
                    }
                }

                if (
                    this.ipStartInfo.method === 2 &&
                    this.ipStartInfo.ips.length > this.ipStartInfo.last
                ) {
                    this.$confirm(
                        "当前剩余连接数不足以分配所选云机，请增加ip最大连接数，或者减少选择云机。",
                        "剩余连接数不足",
                        {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                }

                let allLast = 0;
                if (this.ipStartInfo.method === 1) {
                    this.ipList.forEach(ip => {
                        allLast += ip.connectionLast;
                    });
                }

                if (
                    this.ipStartInfo.method === 1 &&
                    this.ipStartInfo.ips.length > allLast
                ) {
                    this.$confirm(
                        "当前剩余连接数不足以分配所选云机，请增加ip最大连接数，或者减少选择云机。",
                        "剩余连接数不足",
                        {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                }

                let proxyIdList = [];
                if (this.ipStartInfo.method === 1) {
                    if (this.ipStartInfo.global === 1) {
                        this.ipList.forEach(ip => {
                            for (let i = 0; i < ip.connectionLast; i++) {
                                proxyIdList.push(ip.id);
                            }
                        });
                    } else if (this.ipStartInfo.global === 2) {
                        this.ipList.forEach(ip => {
                            if (ip.proxyType === 4 || ip.proxyType === 7) {
                                for (let i = 0; i < ip.connectionLast; i++) {
                                    proxyIdList.push(ip.id);
                                }
                            }
                        });
                    } else if (this.ipStartInfo.global === 3) {
                        this.ipList.forEach(ip => {
                            if (ip.proxyType === 7) {
                                for (let i = 0; i < ip.connectionLast; i++) {
                                    proxyIdList.push(ip.id);
                                }
                            }
                        });
                    }
                    if (proxyIdList.length === 0) {
                        this.$confirm("没有可用的socks5代理", "提醒", {
                            confirmButtonText: "关闭",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            })
                            .catch(() => {
                            });
                        return;
                    }
                }

                let proxyId = this.ipStartInfo.proxyId;
                this.ipStartInfo.ips.forEach(ip => {
                    if (this.ipStartInfo.method === 1) {
                        let index = Math.floor(Math.random() * proxyIdList.length);
                        proxyId = proxyIdList[index];
                        proxyIdList.splice(index, 1);
                    }
                    this
                        .$post(this.$uri.device.startProxy, {
                            deviceIp: ip,
                            proxyId,
                            packageNames: packageNames,
                            isAutoReconnect: this.ipStartInfo.autoConnect,
                            proxyScope: this.ipStartInfo.global
                        })
                        .then(res => {
                        });
                });
                this.$message.success("开始切换IP...");
                this.ipStartPopShow = false;
            },
            ipClose() {
                this.$confirm("确定关闭IP代理？", "提示", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirm-btn-blue",
                    iconClass: "el-icon-c-blue",
                    cancelButtonText: "取消"
                })
                    .then(() => {
                        let devs = [];

                        if (this.viewMode) {
                            devs = this.multipleSelection;
                        } else {
                            for (let i = 0; i < this.info.list.length; i++) {
                                if (this.deviceWindowChecks[i] === true) {
                                    devs.push(this.info.list[i]);
                                }
                            }
                        }

                        let successCount = 0;
                        let devNum = devs.length;
                        let needRebootDevs = [];
                        devs.forEach(dev => {
                            this
                                .$post(this.$uri.device.stopProxy, {deviceIp: dev.deviceIp})
                                .then(res => {
                                    if (!res.success) {
                                        this.$message.error("关闭IP代理(" + dev.deviceIp + ")失败");
                                    } else {
                                        if (dev.proxyType == 5) {
                                            //http代理类型关闭后需要重启云机
                                            needRebootDevs.push(dev.deviceIp);
                                        }
                                        successCount++;
                                        if (successCount === devNum) {
                                            this.$message.success("关闭IP代理成功");
                                            if (needRebootDevs.length > 0) {
                                                // console.log(
                                                //     "need reboot devs is " + needRebootDevs.toString()
                                                // );
                                                this
                                                    .$confirm(
                                                        "关闭http代理的云机(" +
                                                        needRebootDevs.toString() +
                                                        ")需要重启才能生效",
                                                        "提醒",
                                                        {
                                                            confirmButtonText: "确定",
                                                            confirmButtonClass: "confirm-btn-red",
                                                            iconClass: "el-icon-c-red",
                                                            cancelButtonText: "取消",
                                                            showCancelButton: false
                                                        }
                                                    )
                                                    .then(() => {
                                                    })
                                                    .catch(() => {
                                                    });
                                            }
                                        }
                                    }
                                });
                        });
                        this.$message.success("开始关闭IP代理...");
                    })
                    .catch(() => {
                    });
            },
            importPic() {
                this.uploadPicExtraInfo.deviceIps = this.selectIps
                this.$refs.upload.submit()
            },
            avSwitch() {
                if (this.avSwitchInfo.path.length === 0) {
                    this.$confirm("请输入音视频文件路径", "提醒", {
                        confirmButtonText: "关闭",
                        confirmButtonClass: "confirm-btn-red",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return;
                }
                let devs = [];
                if (this.viewMode) {
                    devs = this.multipleSelection;
                } else {
                    for (let i = 0; i < this.info.list.length; i++) {
                        if (this.deviceWindowChecks[i] === true) {
                            devs.push(this.info.list[i]);
                        }
                    }
                }

                let devNum = devs.length;
                let successCount = 0;
                devs.forEach(dev => {
                    this
                        .$post(this.$uri.device.avSwitch, {
                            deviceIp: dev.deviceIp,
                            ...this.avSwitchInfo
                        })
                        .then(res => {
                            if (!res.success) {
                                this.$message.error("音视频播放(" + dev.deviceIp + ")失败");
                            } else {
                                successCount++;
                                if (successCount === devNum) {
                                    this.$message.success("音视频播放成功");
                                }
                            }
                        });
                });
                this.avSwitchPopShow = false;
            },
            liveManage() {
                this
                    .$post(this.$uri.system.paramGet, {paramName: "mediaServerLan"})
                    .then(res => {
                        if (res.success) {
                            this.livePopInfo.mediaAddressLanId = res.data.id;
                            this.livePopInfo.mediaAddressLan = res.data.paramValue;
                            this.livePopInfo.mediaAddressLanName = res.data.paramName;
                        }
                    });

                this
                    .$post(this.$uri.system.paramGet, {paramName: "mediaServerWan"})
                    .then(res => {
                        if (res.success) {
                            this.livePopInfo.mediaAddressWanId = res.data.id;
                            this.livePopInfo.mediaAddressWan = res.data.paramValue;
                            this.livePopInfo.mediaAddressWanName = res.data.paramName;
                        }
                    });

                this.getUrlList();
                this.liveManagePopShow = true;
            },
            getUrlList() {
                this.$post(this.$uri.live.list).then(res => {
                    if (res.success) {
                        res.list.sort((d1, d2) => {
                            return d1.userId - d2.userId;
                        });
                        this.livePopInfo.urlList = res.list;
                    }
                });
            },
            getGroupAppList() {
                this
                    .$post(this.$uri.apk.apkList, {
                        apkStatus: 1,
                        groupId: this.$store.state.groupInfo.id
                    })
                    .then(res => {
                        this.groupAppList = res.list;
                    });
            },
            startStopApk() {
                if (!this.startStopAppid) {
                    this.$message.warning("请选择应用");
                    return;
                }

                if (!this.startStopApp.activity) {
                    this.$confirm(
                        "您选择的应用（" +
                        this.startStopApp.appName +
                        "）在上传后无法识别类名，无法一键启动，需要补充类名后进行？",
                        "提示",
                        {
                            confirmButtonText: "去补充",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-blue",
                            cancelButtonText: "取消"
                        }
                    ).then(() => {
                        this.$store.commit(this.$mutation.APP_DETAIL, this.startStopApp);
                        this.$router.push("/home/app/detail");
                    });
                    return;
                }

                let uri = this.isApkStart
                    ? this.$uri.device.startApp
                    : this.$uri.device.stopApp;
                this
                    .$post(uri, {
                        deviceIps: this.selectIps,
                        appId: this.startStopAppid
                    })
                    .then(res => {
                        if (res.success) {
                            this.$message.success(
                                this.isApkStart ? "启动应用成功" : "停止应用成功"
                            );
                            this.apkStartStopShow = false;
                        } else {
                            this.$message.error(
                                this.isApkStart ? "启动应用失败" : "停止应用失败"
                            );
                        }
                    });
            },
            handleCommand(command) {
                switch (command) {
                    case "reboot":
                        this.rebootOne();
                        break;
                    case "home":
                        this.homeOne();
                        break;
                    case "recover":
                        this.recoverOne();
                        break;
                    case "snapshot":
                        this.snapshotOne();
                        break;
                    case "startApk":
                        this.apkStartStopShow = true;
                        this.getGroupAppList();
                        this.isApkStart = true;
                        break;
                    case "stopApk":
                        this.apkStartStopShow = true;
                        this.getGroupAppList();
                        this.isApkStart = false;
                        break;
                    case "googleInstall":
                        this.installGoogle();
                        break;
                    case "googleUnInstall":
                        this.unInstallGoogle();
                        break;
                }
            },
            adbOpt(deviceIp, on) {
                this.$post(this.$uri.device.turnAdb, {deviceIp, on}).then(res => {
                    if (res.success) {
                        this.$message.success((on === 1 ? "开启" : "关闭") + "成功！");
                    } else {
                        this.$message.error(
                            (on === 1 ? "开启" : "关闭") + "失败！" + res.message
                        );
                    }
                });
            },
            async openSaveMirror(deviceIp, deviceType) {
                // console.log("deviceIp is " + deviceIp);
                this.activeName = "localDevice"
                await this.getMirrorList(deviceIp, deviceType);
                await this.getCurrentMirror(deviceIp)
                if (this.rsyncInfo.address.paramValue.length > 0) {
                    this.saveMirrorPopShow = true;
                    this.clickOnce = false;
                } else {
                    this.saveRsyncPopShow = true;
                }
            },
            async openSwitchMirror(deviceIp, deviceType) {
                // console.log("deviceIp is " + deviceIp);
                this.currentDeviceIp = deviceIp;
                this.currentDeviceType = deviceType
                this.activeName = "localDevice"
                await this.getMirrorList(deviceIp, deviceType)
                await this.getCurrentMirror(deviceIp)
                // console.log("11111111111111111111111")
                this.clickOnce = false
                this.switchMirrorPopShow = true;
                this.$nextTick().then(() => {
                    if (this.$refs.mirrorTable) {
                        this.mirrorTableHeight = window.innerHeight - this.$refs.mirrorTable.$el.offsetTop - 300;
                    }
                })
            },
            cancelSwitchMirror(deviceIp) {
                this.$confirm("确认要取消当前的镜像切换操作?", "提醒", {
                    confirmButtonText: "确认",
                    confirmButtonClass: "confirm-btn-blue",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消",
                    showCancelButton: false
                })
                    .then(() => {
                        let mirrorId = 0;
                        this.allMirrorList.forEach(mirror => {
                            if (mirror.deviceIpInuse == deviceIp && mirror.operationStatus == 12) {
                                mirrorId = mirror.id;
                            }
                        })

                        this.$post(this.$uri.deviceMirror.cancel, {id: mirrorId}).then(res => {
                            if (res.success) {
                                this.$message.success("取消切换成功")
                                this.reload()
                            } else {
                                this.$message.success("取消切换失败")
                            }
                        });
                    }).catch(() => {
                })
            },
            changeRemarkPop(id, remark) {
                this.changeRemarkInfo.id = id;
                this.changeRemarkInfo.remark = remark;
                this.changeRemarkPopShow = true;
            },
            changeRemark() {
                this.changeRemarkInfo.remark = this.changeRemarkInfo.remark.trim();
                if (this.changeRemarkInfo.remark.length > 50) {
                    this.$message.warning("备注不能超过50个字");
                    return;
                }
                this
                    .$post(this.$uri.device.changeRemark, this.changeRemarkInfo)
                    .then(res => {
                        if (res.success) {
                            this.$message.success("修改成功");
                            this.changeRemarkPopShow = false;
                            this.changeMode(this.$store.state.groupDevShowMode);
                        } else {
                            this.$message.error("修改失败");
                        }
                    });
            },
            statusImg(device) {
                if (device.hasOwnProperty('onOff') && device.onOff === 2) {
                    return this.snapShutdown
                } else {
                    return device.deviceStatus === 1
                        ? this.snapNotUpdate
                        : device.deviceStatus === 3
                            ? this.snapError
                            : null;
                }
            },
            downloadSnapshot(index) {
                this
                    .$post(this.$uri.device.snapshot, {
                        deviceIp: [this.info.list[index].deviceIp],
                        isSave: 1,
                        isRetImg: 0
                    })
                    .then(res => {
                        if (res.success) {
                            this.downloadHref =
                                "/snapshot/" +
                                this.info.list[index].deviceNo +
                                ".png?temp=" +
                                Math.random();
                            this.filename = this.info.list[index].deviceNo + ".png";
                            let a = document.createElement("a");
                            a.href = this.downloadHref;
                            a.download = this.filename;
                            a.click();
                        }
                    });
            },
            processProxyName(name) {
                if (!name || name.length == 0) {
                    return "";
                } else if (name.length > 5) {
                    return name.slice(0, 5) + "...";
                } else {
                    return name;
                }
            },
            showQrCode(ip) {
                this.qrCodeIp = ip;
                this.$post(this.$uri.device.qrCode, {deviceIp: ip}).then(res => {
                    this.qrCodeUrl = res.data;
                    this.qrCodeShow = true;
                });

                this
                    .$post(this.$uri.system.paramGet, {paramName: "mediaServerWan"})
                    .then(res => {
                        if (res.success) {
                            this.wanId = res.data.id;
                            this.mediaServerWan = res.data.paramValue;
                        }
                    });
            },
            getImgUrl(no) {
                return "/snapshot/" + no + ".jpg?temp=" + new Date().getTime();
            },
            itemCheckedChange(checked) {
                if (!checked) {
                    this.allChecked = false;
                }
            },
            currentMirrorSaveChange(checked) {
                this.currentMirrorSave = checked;
            },
            rebootOne() {
                if (this.selectIpsHasMirrorOps) {
                    this.$confirm("所选云机正在进行镜像操作，不能重启", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    this.$confirm("重启设备会导致当前应用缓存丢失，是否继续？", "提示", {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-red",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消"
                    })
                        .then(() => {
                            this
                                .$post(this.$uri.device.deviceReboot, {deviceIps: this.selectIps})
                                .then(() => {
                                    this.$message.success("重启指令发送完成，请耐心等待");
                                });
                        })
                        .catch(() => {
                        });
                }
            },
            rebootOneOne(ip, isContainer) {
                var alertStr = "重启设备会导致当前应用缓存丢失，是否继续？";
                if (isContainer === 0) {
                    alertStr = "重启后该云机虚拟化容器也会进行重启，是否确认重启？";
                }
                this.$confirm(alertStr, "提示", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirm-btn-red",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消"
                })
                    .then(() => {
                        this
                            .$post(this.$uri.device.deviceReboot, {deviceIps: [ip]})
                            .then(() => {
                                this.$message.success("重启完成");
                            });
                    })
                    .catch(() => {
                    });
            },
            homeOne() {
                this.$confirm("所有设备返回桌面，是否继续？", "提示", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirm-btn-red",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消"
                })
                    .then(() => {
                        this
                            .$post(this.$uri.device.backHome, {deviceIps: this.selectIps})
                            .then(() => {
                                this.$message.success("返回成功");
                                setTimeout(() => {
                                    this.snapshotOne();
                                }, 1000);
                            });
                    })
                    .catch(() => {
                    });
            },
            recoverOne() {
                if (this.selectIpsHasMirrorOps) {
                    this.$confirm("所选云机正在进行镜像操作，不能恢复出厂设置", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    this.$confirm(
                        "恢复出厂后设备的应用和数据都会被清除， 是否继续？",
                        "提示",
                        {
                            confirmButtonText: "确定",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消"
                        }
                    )
                        .then(() => {
                            this.selectIps.forEach(ip => {
                                this
                                    .$post(this.$uri.device.deviceRestore, {deviceIp: ip})
                                    .then(() => {
                                        this.$message.success("恢复出厂命令已发送");
                                    });
                            });
                        })
                        .catch(() => {
                        });
                }
            },
            installGoogle() {
                if (this.selectIpsHasContainer) {
                    this.$confirm("安装Google框架不能勾选容器，请选择宿主机进行安装", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    if (this.selectIpsHasMirrorOps) {
                        this.$confirm("所选云机正在进行镜像操作，不能安装Google框架", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            }).catch(() => {
                        })
                    } else {
                        this.$confirm("安装Google框架时会自动重启云机两次，是否继续？", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                        })
                            .then(() => {
                                this
                                    .$post(this.$uri.device.installGoogle, {deviceIps: this.selectIps})
                                    .then(res => {
                                        if (res.success) {
                                            this.$message.success("正在安装，请稍候");
                                        }
                                    });
                            })
                            .catch(() => {
                            });
                    }
                }
            },
            unInstallGoogle() {
                if (this.selectIpsHasContainer) {
                    this.$confirm("卸载Google框架不能勾选容器，请选择宿主机进行卸载", "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消",
                        showCancelButton: false
                    })
                        .then(() => {
                        }).catch(() => {
                    })
                } else {
                    if (this.selectIpsHasMirrorOps) {
                        this.$confirm("所选云机正在进行镜像操作，不能卸载Google框架", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                            showCancelButton: false
                        })
                            .then(() => {
                            }).catch(() => {
                        })
                    } else {
                        this.$confirm("卸载Google框架时会自动重启云机，是否继续？", "提醒", {
                            confirmButtonText: "确认",
                            confirmButtonClass: "confirm-btn-blue",
                            iconClass: "el-icon-c-red",
                            cancelButtonText: "取消",
                        })
                            .then(() => {
                                this
                                    .$post(this.$uri.devMaster.unInstallGoogle, {deviceIps: this.selectIps})
                                    .then(res => {
                                        if (res.success) {
                                            this.$message.success("正在卸载，请稍候");
                                        }
                                    });
                            })
                            .catch(() => {
                            });
                    }
                }
            },
            forceRefreshMedia() {
                this.$confirm("刷新媒体库后，相册会对图片和视频文件进行扫描，扫描时间根据文件数量和大小延长，一般为5-10分钟。请确认是否刷新？", "提醒", {
                    confirmButtonText: "确认",
                    confirmButtonClass: "confirm-btn-blue",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消",
                })
                    .then(() => {
                        this
                            .$post(this.$uri.device.refreshMedia, {deviceIps: this.selectIps})
                            .then(res => {
                                if (res.success) {
                                    this.$message.success("刷新成功");
                                }
                            });
                    })
                    .catch(() => {
                    });
            },
            snapshotOne() {
                this.snapshotSuccess = false;
                this.selectIps.forEach(ip => {
                    this.$set(this.snapshotImgLoading, ip, true);
                    this
                        .$post(this.$uri.device.snapshot, {deviceIp: ip, isSave: 0, isRetImg: 1})
                        .then(res => {
                            if (res.success) {
                                this.$set(this.snapshotImg, ip, res.data);
                            }
                            this.$set(this.snapshotImgLoading, ip, false);
                        });
                });
            },
            snapshotAll() {
                this.snapshotSuccess = false;
                this.info.list.forEach(d => {
                    let ip = d.deviceIp;
                    this.$set(this.snapshotImgLoading, ip, true);
                    this
                        .$post(this.$uri.device.snapshot, {deviceIp: ip, isSave: 0, isRetImg: 1})
                        .then(res => {
                            if (res.success) {
                                this.$set(this.snapshotImg, ip, res.data);
                            }
                            this.$set(this.snapshotImgLoading, ip, false);
                        });
                });
            },

            getStatus(ip) {
                let name = this.deviceStatusStr[ip];
                // console.log("name is " + name)
                if (this.scaleMode === 50 && name.length > 2) {
                    return name.slice(0, 2);
                }
                return name;
            },
            mouseEnter(index) {
                // console.log("enter index is " + index);
                this.aaa = index;
            },
            mouseLeave(index) {
                // console.log("leave index is " + index);
                this.aaa = -1;
            },
            sortList(res) {
                res.list.sort((d1, d2) => {
                    if (this.sortKey === 0) {
                        return this.ipToInt(d1.deviceIp) - this.ipToInt(d2.deviceIp);
                    } else if (this.sortKey === 1) {
                        return d1.id >= d2.id ? 1 : -1;
                    } else if (this.sortKey === 2) {
                        if (this.checkNum(d1.remark) && this.checkNum(d2.remark)) {
                            return Number(d1.remark) - Number(d2.remark);
                        } else {
                            return d1.remark >= d2.remark ? -1 : 1;
                        }
                    }
                });

                if (this.sortKey === 0 && !this.viewMode) {
                    let listTmp = [];
                    res.list.forEach(dev => {
                        if (dev.isContainer === 0) {
                            listTmp.push(dev);
                            res.list.forEach(item => {
                                if (item.isContainer === 1 && item.hostIp == dev.deviceIp) {
                                    listTmp.push(item);
                                }
                            });
                        }
                    });
                    res.list = JSON.parse(JSON.stringify(listTmp));
                }
            },
            /* 切换视图模式 */
            changeMode(mode) {
                // console.log("changeMode " + mode)
                this.snapshotSuccess = false;
                this.cleanSelection();
                this.viewMode = mode;
                this.$store.commit(this.$mutation.GROUP_DEV_SHOW_MODE, mode);
                if (!this.viewMode) {
                    this.allChecked = false;
                    this.oldLimit = this.page.limit;
                    let p = {
                        limit: 1000,
                        startPage: 1
                    };

                    this
                        .$post(this.$uri.device.deviceList, {
                            ...p,
                            groupId: this.$store.state.groupInfo.id,
                            queryParam: this.queryParam
                        })
                        .then(res => {
                            this.sortList(res)
                            this.info = res;
                            this.deviceWindowChecks = [];
                            this.info.list.forEach(v => {
                                this.popover[v.deviceIp] = false;
                                if (this.adbPort[v.caseNo] == null) {
                                    this.adbPort[v.caseNo] = 0;
                                    if (v.isContainer === 1) {
                                        var containerId = this.getContainerIdByIP(v.deviceIp);
                                        if (
                                            this.adbPort[v.caseNo - 65536 * containerId] == null ||
                                            this.adbPort[v.caseNo - 65536 * containerId] === 0
                                        ) {
                                            this
                                                .$post(this.$uri.device.caseInfoByCaseNo, {
                                                    caseNo: v.caseNo - 65536 * containerId
                                                })
                                                .then(res => {
                                                    if (res.success && res.data) {
                                                        this.adbPort[v.caseNo - 65536 * containerId] =
                                                            res.data.adbPort;
                                                        this.adbPort[v.caseNo] =
                                                            this.adbPort[v.caseNo - 65536 * containerId] +
                                                            40 * containerId;
                                                    } else {
                                                        this.adbPort[v.caseNo - 65536 * containerId] = null;
                                                        this.adbPort[v.caseNo] = null;
                                                    }
                                                });
                                        } else {
                                            this.adbPort[v.caseNo] =
                                                this.adbPort[v.caseNo - 65536 * containerId] +
                                                40 * containerId;
                                        }
                                    } else {
                                        this
                                            .$post(this.$uri.device.caseInfoByCaseNo, {
                                                caseNo: v.caseNo
                                            })
                                            .then(res => {
                                                if (res.success && res.data) {
                                                    this.adbPort[v.caseNo] = res.data.adbPort;
                                                } else {
                                                    this.adbPort[v.caseNo] = null;
                                                }
                                            });
                                    }
                                }

                                this.deviceWindowChecks.push(false);
                                this.oprShowList.push(false);
                                this.deviceStatusStr[v.deviceIp] = this.statusStrM(v);

                                this
                                    .$post(this.$uri.device.snapshot, {
                                        deviceIp: v.deviceIp,
                                        isSave: 0,
                                        isRetImg: 1
                                    })
                                    .then(res => {
                                        if (res.success) {
                                            this.$set(this.snapshotImg, v.deviceIp, res.data);
                                        }
                                    });
                            });
                        });
                } else {
                    this.$nextTick().then(() => {
                        this.devTableHeight =
                            window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 240;
                        this.getDeviceList();
                    });
                }
            },

            allCheckedChange(checked) {
                if (!this.viewMode) {
                    for (let i = 0; i < this.deviceWindowChecks.length; i++) {
                        if (!this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || this.info.list[i].deviceUuid.length === 0 || this.info.list[i].isAuth === 1) {
                            this.deviceWindowChecks.splice(i, 1, checked);
                        }
                    }
                } else {
                    this.$refs.multipleTable.toggleAllSelection();
                }
            },

            cleanSelection() {
                if (!this.viewMode) {
                    for (let i = 0; i < this.deviceWindowChecks.length; i++) {
                        this.deviceWindowChecks.splice(i, 1, false);
                    }
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
                this.allChecked = false;
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r);
            },
            /* 获取设备列表 */
            getDeviceList() {
                this
                    .$post(this.$uri.device.deviceList, {
                        ...this.page,
                        groupId: this.$store.state.groupInfo.id,
                        queryParam: this.queryParam
                    })
                    .then(res => {
                        this.sortList(res)
                        this.$set(this, "info", res);
                        this.deviceWindowChecks = [];
                        // let smallSpace = false
                        this.info.list.forEach(v => {
                            this.deviceWindowChecks.push(false);
                            this.oprShowList.push(false);
                            this.deviceStatusStr[v.deviceIp] = this.statusStrM(v);
                        });
                    });
            },
            getAllDeviceList() {
                this
                    .$post(this.$uri.device.deviceList, {
                        groupId: this.$store.state.groupInfo.id,
                    })
                    .then(res => {
                        this.lowSpaceDeviceList = [];
                        res.list.forEach(v => {
                            if (v.disk < 10 && v.deviceStatus != 3 && v.deviceStatus != 1) {
                                this.lowSpaceDeviceList.push(v.deviceIp)
                            }
                        });
                        if (this.lowSpaceDeviceList.length > 0) {
                            let msg = "云机(" + this.lowSpaceDeviceList.join("、") + ")存储空间不足10%，存储空间不足可能导致云机故障，请及时清理云机空间。"
                            this.$confirm(msg, "云机空间不足提醒", {
                                confirmButtonText: '知道了',
                                confirmButtonClass: 'confirm-btn-red',
                                iconClass: 'el-icon-c-red',
                                showCancelButton: false,
                            }).then(() => {

                            }).catch(() => {
                            })
                        }
                    });
            },
            /* 获取设备列表 */
            getDeviceList2Refresh() {
                let p = this.page;
                if (!this.viewMode) {
                    p = {
                        limit: 1000,
                        startPage: 1
                    };
                }
                this
                    .$post(this.$uri.device.deviceList, {
                        ...p,
                        groupId: this.$store.state.groupInfo.id,
                        queryParam: this.queryParam
                    })
                    .then(res => {
                        this.sortList(res)
                        this.$set(this, "info", res);
                        // console.log("allDeviceList is ", JSON.stringify(res))
                        this.info.list.forEach(v => {
                            res.list.forEach(i => {
                                if (v.id === i.id) {
                                    v.deviceStatus = i.deviceStatus;
                                    v.isFlow = i.isFlow;
                                    v.proxyIp = i.proxyIp;
                                    v.proxyStatus = i.proxyStatus;
                                    v.proxyName = i.proxyName;
                                }
                                if (
                                    v.id === i.id &&
                                    v.deviceStatus === 1 &&
                                    i.deviceStatus !== 1
                                ) {
                                    setTimeout(() => {
                                        this
                                            .$post(this.$uri.device.snapshot, {
                                                deviceIp: v.deviceIp,
                                                isSave: 0,
                                                isRetImg: 1
                                            })
                                            .then(res => {
                                                if (res.success) {
                                                    this.$set(this.snapshotImg, v.deviceIp, res.data);
                                                }
                                            });
                                    }, 1000);
                                }
                            });
                        });
                        res.list.forEach(i => {
                            this.$set(this.deviceStatusStr, i.deviceIp, this.statusStrM(i));
                        });
                    });
            },
            deviceWindowOpen(id, deviceNo, ip, remark, engineType, mirrorOperationStatus, isAuth, deviceUuid) {
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && deviceUuid.length > 0 && isAuth !== 1) {
                    this.$message.warning("当前云机认证已过期，请联系运维人员");
                    // console.log("mirrorOperationStatus is " + mirrorOperationStatus)
                    return
                }
                if (mirrorOperationStatus != null && mirrorOperationStatus != 5 && mirrorOperationStatus != 14) {
                    this.$message.warning("当前云机正在执行镜像操作，无法进行推流");
                    // console.log("mirrorOperationStatus is " + mirrorOperationStatus)
                    return
                }
                if (
                    this.$store.state.licenseInfo &&
                    this.checkLicenseService(6) === -1 &&
                    this.$store.state.deviceWindowMode.length > 0
                ) {
                    return;
                }

                let hasSign = false;
                this.$store.state.deviceWindowMode.forEach(mode => {
                    if (id === mode.id) {
                        hasSign = true;
                    }
                });
                if (hasSign) {
                    this.$message.warning("当前云机的推流窗口已打开");
                    return;
                }
                this.$store.commit(this.$mutation.DEVICE_WINDOW_SHOW_MODE, {
                    show: true,
                    mode: {
                        show: true,
                        id,
                        remark,
                        deviceNo,
                        ip: ip,
                        engineType
                    }
                });
            },
            isCommonCard(row, index) {
                // return row.cardType === 1
                if (!this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || row.deviceUuid.length === 0 || row.isAuth === 1)
                    return true;
            },
            rowKey(row) {
                return row.id;
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val;
                this.getDeviceList();
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val;
                this.getDeviceList();
            },
            /* 当前页改变 */
            currentMirrorChangeHandle(val) {
                this.mirrorPage.startPage = val;
            },
            mirrorSizeChangeHandle(val) {
                this.mirrorPage.limit = val;
            },
            canSelect(row, index) {
                return !this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0 || row.deviceUuid.length === 0 || row.isAuth === 1
            },
            tableRowClassName({row, index}) {
                if (this.$store.state.licenseInfo.hasOwnProperty("isNew") && this.$store.state.licenseInfo.isNew == 1 && row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return 'not-auth-color';
                }
                return 'auth-color'
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            /* 删除设备 */
            async deleteDev(deviceIp) {
                await this.$post(this.$uri.device.deviceDelete, {deviceIp});
            },
            /* 批量删除设备 */
            deleteDevBatch() {
                this.$confirm(
                    "删除设备会导致设备恢复出厂设置，清除数据，是否继续？",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-red",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        let deviceIps = [];
                        this.multipleSelection.forEach(v => {
                            deviceIps.push(v.deviceIp);
                        });
                        this.$post(this.$uri.device.deviceDelete, {deviceIps}).then(res => {
                            this.$message.success("删除完成");
                            this.getDeviceList();
                        });
                    })
                    .catch(() => {
                    });
            },
            /* 设备重启 */
            async rebootDev(deviceIp) {
                await this.$post(this.$uri.device.deviceReboot, {deviceIp});
            },
            /* 设备批量重启 */
            rebootDevBatch() {
                this.$confirm("重启设备会导致当前应用缓存丢失，是否继续？", "提示", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirm-btn-red",
                    iconClass: "el-icon-c-red",
                    cancelButtonText: "取消"
                })
                    .then(() => {
                        let deviceIps = [];
                        this.multipleSelection.forEach(v => {
                            deviceIps.push(v.deviceIp);
                        });
                        this.$post(this.$uri.device.deviceReboot, {deviceIps}).then(res => {
                            this.$message.success("重启完成");
                            this.getDeviceList();
                        });
                    })
                    .catch(() => {
                    });
            },
            /* 恢复出厂设置 */
            initDev(deviceIp) {
                this.$confirm(
                    "恢复出厂后设备的应用和数据都会被清除， 是否继续？",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        confirmButtonClass: "confirm-btn-red",
                        iconClass: "el-icon-c-red",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        this.$post(this.$uri.device.deviceRestore, {deviceIp}).then(res => {
                            this.$message.success("恢复出厂设置成功");
                        });
                    })
                    .catch(() => {
                    });
            },
            /* 设备回收 */
            recoverDev(deviceIp) {
                this.$post(this.$uri.device.deviceRecover, {deviceIp}).then(res => {
                    this.$message.success("回收成功");
                });
            },
            /* 获得分组信息 */
            getGroupList() {
                this.$post(this.$uri.group.list, {}).then(res => {
                    let options = [];
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.groupName
                        });
                    });
                    this.options = options;
                });
            },

            saveDeviceMirror() {
                if (this.mirrorIsCover == false && this.mirrorRemark.length == 0) {
                    this.$confirm(
                        "镜像备注不允许为空， 请输入镜像备注",
                        "提示",
                        {
                            confirmButtonText: "确定",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            showCancelButton: false
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                    return
                }
                let newRemark = this.mirrorIsCover ? this.currentMirror.remark : this.mirrorRemark
                let param = {
                    deviceIp: this.currentMirror.deviceIp,
                    remark: newRemark,
                    isCover: this.mirrorIsCover ? 1 : 0,
                    isDeviceMasterM: this.isDeviceMasterM ? 1 : 0,
                };
                this.clickOnce = true
                // console.log("param is " + JSON.stringify(param));
                this.$post(this.$uri.deviceMirror.save, param).then(res => {
                    if (res.success) {
                        this.$message.success(
                            "开始保存镜像，设备可能会有较长时间处于关闭状态，请等待"
                        );
                    }
                    this.saveMirrorPopShow = false;
                    this.reload()
                });
            },
            switchMirrorProcess() {
                if (this.switchMirrorId == 0) {
                    this.$confirm(
                        "请选择需要切换的镜像",
                        "提示",
                        {
                            confirmButtonText: "确定",
                            confirmButtonClass: "confirm-btn-red",
                            iconClass: "el-icon-c-red",
                            showCancelButton: false
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                } else {
                    if (this.currentMirror.remark.length == 0) {
                        this.currentMirrorSave = false
                    }
                    let deviceMasterM = 0
                    if (this.currentMirrorSave && this.isDeviceMasterM) {
                        deviceMasterM = 1
                    }
                    let param = {
                        deviceIp: this.currentMirror.deviceIp,
                        deviceMirrorId: this.switchMirrorId,
                        isSave: this.currentMirrorSave ? 1 : 0,
                        isCover: this.currentMirrorSave ? 1 : 0,
                        isDeviceMasterM: deviceMasterM,
                    };
                    this.clickOnce = true
                    // console.log("switchMirrorProcess param is " + JSON.stringify(param));
                    this.$post(this.$uri.deviceMirror.switch, param).then(res => {
                        if (res.success) {
                            this.$message.success(
                                "开始切换镜像，设备可能会有较长时间处于关闭状态，请等待"
                            );
                        }
                        this.switchMirrorPopShow = false;
                        this.reload()
                    });
                }
            },
            /* 设备分组 */
            groupDev() {
                this.$post(this.$uri.device.deviceGrouping, this.groupInfo).then(res => {
                    this.$message.success("分组成功");
                    this.groupDevPopShow = false;
                });
            },
            /* 弹出分组弹框 */
            groupDevPop(deviceIp) {
                this.groupDevPopShow = true;
                this.groupInfo.deviceIp = deviceIp;
            },
            /* 获取所有引擎版本信息 */
            getEngineVersion() {
                this.$post(this.$uri.system.engineList, {}).then(res => {
                    let list = [];
                    res.data.forEach(v => {
                        list.push({
                            label: v.engineTypeName,
                            value: v.engineType
                        });
                    });
                    this.searchOptions.version = list;
                });
            },

            /* 10s刷新一次数据 */
            refreshDevList() {
                if (this.$route.meta.refresh && !this.viewMode) {
                    this.getDeviceList2Refresh();
                    if (this.checkLicenseService(30) != -1 || this.checkLicenseService(31) != -1) {
                        this.getAllMirrorList()
                    }
                    this.timeoutId = setTimeout(() => {
                        this.refreshDevList();
                    }, 5000);
                }
            },
            statusStrM(row) {
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    return "推流中";
                } else if (row.deviceMirrorOperationStatus != null && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    // console.log("row is " + JSON.stringify(row))
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            return "镜像准备中";
                        case 1:
                            return "镜像保存中";
                        case 2:
                            return "镜像保存失败";
                        case 3:
                            return "镜像上传中";
                        case 4:
                            return "镜像上传失败";
                        case 10:
                            return "镜像下载中";
                        case 11:
                            return "镜像下载失败";
                        case 12:
                            return "镜像切换中";
                        case 13:
                            return "镜像切换失败";
                        case 20:
                            return '命令发送失败'
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            return "";
                        case 1:
                            if (row.onOff == 2) {
                                return "已关机"
                            } else {
                                return "未更新"
                            }
                        case 2:
                            return "应用安装中";
                        case 3:
                            if (row.onOff == 2) {
                                return "已关机"
                            } else {
                                return "故障"
                            }
                        case 4:
                            return "预启动";
                        case 5:
                            return "清理中";
                        case 6:
                            return "升级中";
                        case 7:
                            return "应用结束中";
                    }
                }
            },
            getDeviceType() {
                this.$post(this.$uri.system.paramGet, {paramName: "systemType"}).then(res => {
                    console.log("getDeviceType " + JSON.stringify(res))
                    if (res.success) {
                        this.systemType = parseInt(res.data.paramValue)
                    }
                })
            },
            adbPortFilter(row) {
                let port = this.adbPort[row.caseNo] || 0;
                let num1 = parseInt(row.slotNo.substr(0, row.slotNo.indexOf(".")));
                let num2 = parseInt(row.slotNo.substr(row.slotNo.indexOf(".") + 1));
                if (this.systemType == 2) {
                    return port + num1;
                } else {
                    return port + num1 * 2 + num2;
                }
            },
            showDeviceToolTip(row) {
                // console.log("row is " + JSON.stringify(row))
                if (row.deviceUuid.length > 0 && row.isAuth === 0) {
                    return "该设备未通过认证，请联系运维人员"
                } else if (row.deviceUuid.length > 0 && row.isAuth === 2) {
                    return "该设备认证过期，请联系运维人员"
                } else {
                    return "该设备已认证"
                }
            },
            getLicense() {
                let licenseNew = {}
                this.$post(this.$uri.system.licenseGet).then(res => {
                    if (res.success) {
                        licenseNew = res.data
                        if (licenseNew.hasOwnProperty("isNew") && licenseNew.isNew == 1) {
                            if (licenseNew.secondsLeft === 0) {
                                // console.log("license secondsLeft is 0")
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
                            } else {
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)
                            }

                            if (licenseNew.service) {
                                let serviceItems = licenseNew.service.toString().split(",")
                                // console.log("serviceItems is " + serviceItems)
                                serviceItems.forEach(item => {
                                    if (item == 0) {
                                        this.$store.commit(this.$mutation.ENABLE_CMD_FORWARD)
                                    } else if (item == 1) {
                                        this.$store.commit(this.$mutation.ENABLE_IP_PROXY)
                                    } else if (item == 2) {
                                        this.$store.commit(this.$mutation.ENABLE_DEV_MASTER)
                                    } else if (item == 30) {
                                        this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                    }
                                })
                            }
                        } else {
                            if (licenseNew.secondsLeft === 0) {
                                // console.log("license secondsLeft is 0")
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
                            } else {
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)

                                if (licenseNew.service) {
                                    let serviceItems = licenseNew.service.toString().split(",")
                                    // console.log("serviceItems is " + serviceItems)
                                    serviceItems.forEach(item => {
                                        // console.log("item is " + item)
                                        if (item == 0) {
                                            this.$store.commit(this.$mutation.ENABLE_CMD_FORWARD)
                                        } else if (item == 1) {
                                            this.$store.commit(this.$mutation.ENABLE_IP_PROXY)
                                        } else if (item == 2) {
                                            this.$store.commit(this.$mutation.ENABLE_DEV_MASTER)
                                        } else if (item == 30) {
                                            this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                        } else if (item == 31) {
                                            this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                        }
                                    })
                                }
                            }
                        }
                        this.$store.commit(this.$mutation.LICENSE_SAVE, licenseNew)
                        this.$store.commit(this.$mutation.ENABLE_PHONE_MODEL)

                        // console.log("licenseInfo is " + JSON.stringify(licenseNew))
                        this.licenseInfo = JSON.parse(JSON.stringify(licenseNew))
                    }
                })
            },
        },
        filters: {
            devCodeStr(row) {
                if (row.isContainer === 1) {
                    if (row.engineType <= 12 || row.engineType == 17 || row.engineType == 18 || row.engineType == 23) {
                        return "容器-ry-" + row.deviceNo;
                    } else if ((row.engineType >= 13 && row.engineType <= 15) || row.engineType === 22) {
                        return "容器-gt-" + row.deviceNo;
                    } else {
                        return "容器-ot-" + row.deviceNo;
                    }
                } else if (row.isContainer === 0) {
                    if (row.engineType <= 12 || row.engineType == 17 || row.engineType == 18 || row.engineType == 23) {
                        return "宿主机-ry-" + row.deviceNo;
                    } else if ((row.engineType >= 13 && row.engineType <= 15) || row.engineType === 22) {
                        return "宿主机-gt-" + row.deviceNo;
                    } else {
                        return "宿主机-ot-" + row.deviceNo;
                    }
                }
            },
            statusStr(row) {
                let status = ""
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    status = "推流中";
                } else if (row.deviceMirrorOperationStatus != null && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    // console.log("row is " + JSON.stringify(row))
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            status = "镜像准备中";
                            break
                        case 1:
                            status = "镜像保存中";
                            break
                        case 2:
                            status = "镜像保存失败";
                            break
                        case 3:
                            status = "镜像上传中";
                            break
                        case 4:
                            status = "镜像上传失败";
                            break
                        case 10:
                            status = "镜像下载中";
                            break
                        case 11:
                            status = "镜像下载失败";
                            break
                        case 12:
                            status = "镜像切换中";
                            break
                        case 13:
                            status = "镜像切换失败";
                            break
                        case 20:
                            status = '命令发送失败';
                            break;
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            status = "正常";
                            break
                        case 1:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "未更新"
                            }
                            break
                        case 2:
                            status = "应用安装中";
                            break
                        case 3:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "故障";
                            }
                            break
                        case 4:
                            status = "预启动";
                            break
                        case 5:
                            status = "清理中";
                            break
                        case 6:
                            status = "升级中";
                            break
                        case 7:
                            status = "应用结束中";
                            break
                    }
                }
                return status;
            },
            authStatusStr(row) {
                let status = ""

                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    status = "<认证失败>"
                }
                return status;
            },
            statusClassFilter(row) {
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    return {color: "green"};
                } else if (row.deviceMirrorOperationStatus && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            return {color: "green"};
                        case 1:
                            return {color: "green"};
                        case 2:
                            return {color: "red"};
                        case 3:
                            return {color: "green"};
                        case 4:
                            return {color: "red"};
                        case 10:
                            return {color: "green"};
                        case 11:
                            return {color: "red"};
                        case 12:
                            return {color: "green"};
                        case 13:
                            return {color: "red"};
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            return {color: "green"};
                        case 3:
                            return {color: "red"};
                        default:
                            return {color: "#eab820"};
                    }
                }
            },
            authStatusClassFilter(row) {
                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return {
                        color: "#aaa",
                        maxWidth: "100px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    };
                }
            }
        },
        beforeMount() {
            this.getLicense()
        },
        mounted() {
            this.displayMode = this.$store.state.displayMode;
            this.scaleMode = this.$store.state.scaleMode;
            this.sortKey = this.$store.state.sortMode;
            this.snapshotTime = this.$store.state.refreshTime;
            this.changeMode(this.$store.state.groupDevShowMode);
            this.getDeviceType();
            this.getGroupList();
            this.getAppsForDeviceGroup();
            this.getEngineVersion();
            this.refreshDevList();
            this.snapshotAuto();
            this.getNationList();
            this.getAllDeviceList();
            this.getRsyncParams();
        },
        beforeDestroy() {
            clearTimeout(this.timeoutId);
            clearInterval(this.snapshotAutoId);
            if (this.cpuTimer.length > 0) {
                this.cpuTimer.forEach(item => {
                    // console.log("clear Timer");
                    clearInterval(item);
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .dev-list {
        padding-bottom: 20px;
        .preview-bar {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            .preview-bar-operate {
                /*flex-grow: 1;*/
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                /*width: 100%;*/
            }
            .preview-bar-cut {
                font-size: 16px;
            }
        }
        .preview-main {
            display: flex;
            flex-direction: row;
            /*height: 650px;*/
            /*padding-bottom: 60px;*/
            /*background-color: red;*/
            overflow-y: scroll;
            /*justify-content: space-between;*/
            flex-wrap: wrap;
            .snapshot-main {
                /*border: 1px solid #f6f6f6;*/
                background-color: #f6f6f6;
                border-radius: 0px;
                .snapshot-main-head {
                    padding: 0 5px;
                    width: 100%;
                }
                .snapshot-main-img {
                }
            }
            #snapshot-main :hover {
                border: 1px solid #409eff;
                border-radius: 6px;
            }
        }
        .preview-main :after {
            content: "";
            /*width: 200px;*/
        }
        .preview-main::-webkit-scrollbar {
            display: none;
        }
        /*.dev-list-search {*/
            /*width: 100%;*/
            /*display: flex;*/
            /*flex-direction: column;*/
            /*.search-btn {*/
                /*display: flex;*/
                /*flex-direction: row;*/
                /*justify-content: space-between;*/
            /*}*/
            /*.search-advanced {*/
                /*display: flex;*/
                /*flex-direction: column;*/
                /*.search-main {*/
                    /*margin-top: 10px;*/
                    /*display: flex;*/
                    /*flex-direction: row;*/
                    /*justify-content: space-between;*/
                    /*flex-wrap: wrap;*/
                    /*.search-main-item {*/
                        /*width: 24%;*/
                        /*display: flex;*/
                        /*flex-direction: row;*/
                        /*justify-content: space-between;*/
                        /*align-items: center;*/
                        /*!*flex-grow: 1;*!*/
                        /*padding: 5px 10px;*/
                        /*span {*/
                            /*font-size: 12px;*/
                        /*}*/
                        /*.item-input {*/
                            /*width: 180px;*/
                        /*}*/
                    /*}*/
                /*}*/
                /*.search-btn {*/
                    /*padding: 0 10px;*/
                    /*display: flex;*/
                    /*flex-direction: row;*/
                    /*justify-content: flex-end;*/
                    /*align-items: center;*/
                /*}*/
            /*}*/
        /*}*/
        .device-case-dev {
            .list-bottom {
                padding: 10px;
                margin-right: 10px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }

    .el-loading-mask {
        background-color: rgba(0, 0, 0, 0.1);
    }

    .bottom-area {
        position: fixed;
        bottom: 0;
        margin-left: -20px;
        width: 100%;
        height: 50px;
        background-color: white;
        border-top: 1px solid #ddd;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding-left: 20px;
        font-size: 14px;
        z-index: 9999;
        .el-button {
            margin-left: 1%;
        }
        /*overflow-x: scroll;*/
    }

    .pop_button_area {
        width: 100%;
        height: 32px;
        display: flex;
        flex-direction: row;
        margin-top: 4px;
        margin-left: 4px;
    }

    .pop_span {
        margin-top: 4px;
        font-size: 12px;
    }

    .pop_button {
        /*width: 54px;*/
        height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    /deep/ .el-switch {
        position: relative;
        height: 24px;
        line-height: 24px;
        &.is-checked {
            .el-switch__core {
                background: #179bff;
                &:after {
                    margin-left: -22px;
                }
            }
        }
        .el-switch__label,
        .el-switch__core {
            height: 24px;
        }
        .el-switch__core {
            border-radius: 12px;
            border: none;
            background: #f1f1f1;
            &:after {
                box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
                width: 22px;
                height: 22px;
            }
        }
        .el-switch__label.is-active {
            color: #333;
        }
        .el-switch__label--right {
            margin-left: 0px;
            &.is-active {
                color: #fff;
                right: 24px;
            }
            position: absolute;
            right: 5px;
            top: -1px;
            color: #fff;
            > span {
                font-size: 12px;
            }
        }
    }

    .guard_master_box {
        width: 84%;
        height: 300px;
        margin-top: 15px;
        overflow-x: hidden;
        overflow-y: scroll;
        border: 1px solid #ddd;
    }

    .guard_master_box::-webkit-scrollbar {
        display: none;
    }

    .clean_app_box {
        width: 84%;
        height: 260px;
        margin-top: 15px;
        overflow: auto;
        border: 1px solid #ddd;
    }

    /deep/ .app_clean_list {
        .el-scrollbar__thumb {
            background-color: #73abb1;
        }
    }

    .model_selfedit_box {
        width: 80%;
        height: 100px;
        margin-top: 15px;
        overflow-x: hidden;
        overflow-y: scroll;
        border: 1px solid #ddd;
        padding: 2%;
    }

    .model_selfedit_box::-webkit-scrollbar {
        display: none;
    }

    .dev_buttons {
        position: absolute;
        left: 0;
        top: 0px;
        z-index: 1111;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .ipproxy-list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .mirror-list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
        word-break: break-all;
        overflow: hidden;
    }

    .right-tabbox-newnotice {
        margin-top: 20px;
    }

    .right-tabbox-newnotice /deep/ .el-tabs__nav-wrap::after {
        position: static !important;
    }

    .dev-master-others {
        display: flex;
        flex-direction: row;
        width: 84%;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        align-items: center;
        justify-content: flex-start;
    }

    .device-status-span {
        padding-right: 5px;
        font-size: 11px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ip_proxy_tips {
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        span {
            margin-top: 5px;
            color: red;
            font-size: 14px;
        }
    }
</style>
